import update from "immutability-helper";
import _ from "lodash";
import moment from "moment";
import { store } from "..";
import { percentageByEnum } from "../data/common.data";
import { ADT_SUB_TYPES, ADT_TABLE_TYPE, CUSTOM_TAB_TYPE, TOTAL_TYPE } from "../types/common.type";
import { ACCOUNT_PERCENTAGE_BY, OVERALL_PAGE_SUB_TYPE, PAGE_TYPE } from "../types/pages.type";
import { NUMBER_RANGE_TYPE, QUESTION_INPUT_TYPE, TIME_RANGE_TYPE, HOURLY_TIME_RANGES, QUESTIONS_TEMPLATE_TYPE } from "../types/question.type";

export async function processCustomChartFiltersADT(chartMainDataArr, filters, newChecked, filterData) {
	const filterList = filterData;
	const isOtherDashboard = filters?.question?.isAnotherDashboard || filters?.question?.level > 0;

	const isRowChecked = (row) =>
		newChecked.some(
			(id) => id === row?._id || id === row?.id || id === row?.key
		);

	const patientIds =
		filterList?.reduce((acc, ele) => {
			if (!isRowChecked(ele)) return acc;
			const { patientIds: pids = [], Ids = [], otherDashboardIds = [] } = ele || {};
			if (isOtherDashboard) {
				acc.push(...(otherDashboardIds.length ? otherDashboardIds : pids.length ? pids : Ids));
			} else {
				acc.push(...(pids.length ? pids : Ids));
			}
			return acc;
		}, []) || [];

	const filterType = typeof filters?.type === "string" ? filters.type : filters?.type?.childId;

	return filterCustomPatientData(chartMainDataArr, { [filterType]: newChecked }, {
		...filters,
		patientIds,
		type: filterType,
	});
}

export async function processCustomChartFilters(chartMainDataArr, filters, newChecked, forComparison = false) {
	const filterList = filters?.question?.customTab?.isCustomDateAnalysis ? filters?.customRangeCombinedData : filters?.filterListData?.[filters?.type];
	const isOtherDashboard = filters?.question?.isAnotherDashboard || filters?.question?.level > 0;
	const patientIds =
		filterList?.reduce((acc, ele) => {
			const { _id, patientIds = [], Ids = [], otherDashboardIds = [] } = ele || {};

			if (!_.includes(newChecked, _id)) return acc;

			const isSixtyOrNinetyDay =
				typeof filters?.type === 'string' &&
				(
					filters.type.includes('sixtyDaysData') ||
					filters.type.includes('ninetyDaysData') ||
					/Days.*tab/i.test(filters.type)
				);

			if (filters?.question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab) {
				acc.push(...(patientIds.length ? patientIds : Ids));
			} else {
				if (isOtherDashboard) {
					acc.push(...(isSixtyOrNinetyDay ? patientIds.length ? patientIds : Ids : otherDashboardIds));
				} else {
					acc.push(...(patientIds.length ? patientIds : Ids));
				}
			}
			return acc;
		}, []) || [];

	const newChartFilters = filterCustomPatientData(
		chartMainDataArr,
		{ [filters?.type]: newChecked },
		{
			...filters,
			patientIds,
		}
	);

	return newChartFilters;
}

export function filterCustomPatientData(patientFilterData, cardFilter, ele, isDebug = false) {
	return _.filter(patientFilterData, (eleAccessor) => {
		const questionType = ele?.question?.customQuestionInputType;

		if (questionType === QUESTION_INPUT_TYPE.UNLIMITED_ANSWERS) {
			const accessor = ele?.type;
			const filterValues = cardFilter?.[accessor] || [];
			const elementValue = eleAccessor?.[accessor] || null;
			// return filterValues.length === 0 || _.includes(filterValues, elementValue);
			return filterValues?.includes(elementValue);
		}

		if (questionType === QUESTION_INPUT_TYPE.LIMITED_ANSWERS) {
			if (!cardFilter) return true;

			const accessor = ele?.type;
			const filterValues = cardFilter?.[accessor] || [];
			const elementValue = eleAccessor?.[accessor] || null;

			// return filterValues.length === 0 || _.includes(filterValues, elementValue);
			return filterValues?.includes(elementValue);
		}

		if (
			questionType === QUESTION_INPUT_TYPE.NUMBER_RANGE ||
			questionType === QUESTION_INPUT_TYPE.NUMBER_RANGE_LIMITED_ANSWERS ||
			questionType === QUESTION_INPUT_TYPE.TIME_TAB_RANGE ||
			questionType === QUESTION_INPUT_TYPE.DATE_ANALYSIS ||
			questionType === QUESTION_INPUT_TYPE.DATE
		) {
			const rowIds = [eleAccessor?._id, eleAccessor?.id].filter((v) => v != null).map(String);
			return ele?.patientIds?.some((pid) => rowIds.includes(String(pid)));
		}
		if (!questionType) {
			const rowIds = [eleAccessor?._id, eleAccessor?.id].filter((v) => v != null).map(String);
			return ele?.patientIds?.some((pid) => rowIds.includes(String(pid)));
		}
		return true;
	});
}

export async function customDataTabFilter(data, totalFilter, accessor) {
	//insuranceData Cal
	let insuranceDBDataGroup = [];
	if (data && data.length > 0) {

		const insuranceDBData = _.groupBy(data, accessor);
		const originalData = _.groupBy(totalFilter.originalData, accessor);
		let percentageTotal = totalFilter?.totalForPercentage ? totalFilter.totalForPercentage : data?.length;

		if (insuranceDBData) {
			insuranceDBDataGroup = await filterListDataItems(insuranceDBData, accessor, percentageTotal, {
				...totalFilter,
				originalData,
			});
		}
	}

	return insuranceDBDataGroup;
}

const getFilteredPatients = (patients, accessor, item) => {
	if (item?.invisibleAnswerOptions && item?.dataInputLabel) {
		const invisibleLabels = item.dataInputLabel.split(',').map(label => label.trim()).filter(Boolean);
		if (invisibleLabels.length > 0) {
			return patients?.filter(patient => {
				const val = patient?.[accessor];
				return !invisibleLabels.includes(val);
			}) ?? [];
		}
	}
	return patients ?? [];
};

const getFilteredIntermediateTotals = (intermediateTotals, accessor, item) => {
	if (!intermediateTotals) return {};
	const filtered = {};
	Object.keys(intermediateTotals).forEach(level => {
		filtered[level] = getFilteredPatients(intermediateTotals[level], accessor, item);
	});
	return filtered;
};

const calculateTotalResponses = (patients, accessor, options, totalFilter, item = null) => {
	const patientsData = getFilteredPatients(patients, accessor, item);
	let percentageTotal = totalFilter?.totalForPercentage ? totalFilter.totalForPercentage : patientsData?.length;
	const totalType = totalFilter?.totalType;
	let isADT = totalFilter?.isADT ?? false;
	const isOtherDashboard = totalFilter?.isOtherDashboard ?? false;
	const isSort = totalFilter?.isSort ?? false;
	const originalData = totalFilter?.originalData ?? [];
	const isTooltip = totalType && totalType === TOTAL_TYPE.MAIN ? false : true;

	const responseCounts = patientsData?.reduce((acc, patient) => {
		const value = patient?.[accessor];
		if (value !== undefined) {
			if (!acc[value]) {
				acc[value] = { count: 0, patientIds: [], admissionIds: [], refPatientIds: [] }; // Initialize patientIds array
			}
			acc[value].count++;
			acc[value].patientIds.push(patient._id); // Store patient IDs
			acc[value].refPatientIds.push(patient.refPatientId); // Store patient IDs
			acc[value].admissionIds.push(patient.admissionId);
		}
		return acc;
	}, {});

	const originalDataFiltered = getFilteredPatients(originalData, accessor, item);
	const responseCountsOriginal = originalDataFiltered?.reduce((acc, patient) => {
		const value = patient?.[accessor];
		if (value !== undefined) {
			if (!acc[value]) {
				acc[value] = { count: 0, patientIds: [], admissionIds: [], refPatientIds: [] }; // Initialize patientIds array
			}
			acc[value].count++;
		}
		return acc;
	}, {});

	// Calculate intermediate level totals
	const filteredIntermediateTotals = getFilteredIntermediateTotals(totalFilter?.intermediateTotals, accessor, item);
	const currentLevel = totalFilter?.currentLevel || 0;
	const cardTitles = totalFilter?.cardTitles || {};

	const level1Counts = {};
	if (currentLevel >= 2 && Array.isArray(filteredIntermediateTotals?.level1)) {
		filteredIntermediateTotals.level1.forEach(patient => {
			const value = patient?.[accessor];
			if (value !== undefined) {
				level1Counts[value] = (level1Counts[value] || 0) + 1;
			}
		});
	}

	const level2Counts = {};
	if (currentLevel >= 3 && Array.isArray(filteredIntermediateTotals?.level2)) {
		filteredIntermediateTotals.level2.forEach(patient => {
			const value = patient?.[accessor];
			if (value !== undefined) {
				level2Counts[value] = (level2Counts[value] || 0) + 1;
			}
		});
	}

	const level3Counts = {};
	if (currentLevel >= 4 && Array.isArray(filteredIntermediateTotals?.level3)) {
		filteredIntermediateTotals.level3.forEach(patient => {
			const value = patient?.[accessor];
			if (value !== undefined) {
				level3Counts[value] = (level3Counts[value] || 0) + 1;
			}
		});
	}

	const level4Counts = {};
	if (currentLevel >= 5 && Array.isArray(filteredIntermediateTotals?.level4)) {
		filteredIntermediateTotals.level4.forEach(patient => {
			const value = patient?.[accessor];
			if (value !== undefined) {
				level4Counts[value] = (level4Counts[value] || 0) + 1;
			}
		});
	}

	const level5Counts = {};
	if (currentLevel >= 6 && Array.isArray(filteredIntermediateTotals?.level5)) {
		filteredIntermediateTotals.level5.forEach(patient => {
			const value = patient?.[accessor];
			if (value !== undefined) {
				level5Counts[value] = (level5Counts[value] || 0) + 1;
			}
		});
	}

	let resOptions = options?.map((option) => {
		const optionId = option._id ?? option;
		const label = option.label ?? option;
		const totalRes = responseCounts?.[optionId]?.count || 0;
		const totalResOriginal = responseCountsOriginal?.[optionId]?.count || 0;
		const patientIds = responseCounts?.[optionId]?.patientIds || [];
		const patientRefIds = responseCounts?.[optionId]?.refPatientIds || [];
		const admissionIds = responseCounts?.[optionId]?.admissionIds || [];
		const uniquePatientIds = [...new Set(patientIds || [])];

		const result = {
			_id: optionId,
			id: optionId,
			label,
			name: label,
			type: option.type || undefined,
			total: totalRes,
			value: totalRes,
			originalTotal: totalResOriginal,
			percentage: itemPercentage(totalRes, percentageTotal, "number"),
			patientIds: isOtherDashboard ? patientRefIds : patientIds,
			level: totalFilter?.level || 0,
			isTooltip,
			...(currentLevel >= 2 && { level1Total: level1Counts[optionId] || 0 }),
			...(currentLevel >= 3 && { level2Total: level2Counts[optionId] || 0 }),
			...(currentLevel >= 4 && { level3Total: level3Counts[optionId] || 0 }),
			...(currentLevel >= 5 && { level4Total: level4Counts[optionId] || 0 }),
			...(currentLevel >= 6 && { level5Total: level5Counts[optionId] || 0 }),
			...(currentLevel >= 2 && cardTitles?.level1 && { level1CardTitle: cardTitles.level1 }),
			...(currentLevel >= 3 && cardTitles?.level2 && { level2CardTitle: cardTitles.level2 }),
			...(currentLevel >= 4 && cardTitles?.level3 && { level3CardTitle: cardTitles.level3 }),
			...(currentLevel >= 5 && cardTitles?.level4 && { level4CardTitle: cardTitles.level4 }),
			...(currentLevel >= 6 && cardTitles?.level5 && { level5CardTitle: cardTitles.level5 }),
			...(isOtherDashboard) && { otherDashboardIds: uniquePatientIds },
			...(isADT && { transferIds: patientIds }),
			...(isADT && { admissionIds: admissionIds }),
			...(isADT && { ids: patientIds }),
			...(isADT && { type: ADT_TABLE_TYPE.CUSTOM }),
		};

		if (totalType === QUESTION_INPUT_TYPE.UNLIMITED_ANSWERS && totalRes <= 0) {
			return null;
		}
		return result;
	}).filter(Boolean) ?? [];

	if (isSort) {
		resOptions = _.orderBy(resOptions, "total", "desc");
	}

	return resOptions;
};

const calculateTotalOrAverage = (patients, accessor, type, title, patientIds, isADT = false, totalFilterData, item = null) => {
	const patientsFiltered = getFilteredPatients(patients, accessor, item);
	const originalDataFiltered = getFilteredPatients(totalFilterData?.originalData, accessor, item);

	const patientsFilterArr = patientsFiltered?.filter(patient => patient?.[accessor] != null) || [];
	const patientsFilterArrOriginal = originalDataFiltered?.filter(patient => patient?.[accessor] != null) || [];
	const isTooltip = totalFilterData?.totalType && totalFilterData?.totalType === TOTAL_TYPE.MAIN ? false : true;

	const total = patientsFilterArr.reduce((sum, patient) => {
		const value = Number(patient[accessor]);
		return !isNaN(value) ? sum + value : sum;  // Only add numeric values
	}, 0);

	const totalOriginal = patientsFilterArrOriginal.reduce((sum, patient) => {
		const value = Number(patient[accessor]);
		return !isNaN(value) ? sum + value : sum;  // Only add numeric values
	}, 0);

	const average = patientsFilterArr.length > 0 ? total / patientsFilterArr.length : 0;
	const averageOriginal = patientsFilterArrOriginal.length > 0 ? totalOriginal / patientsFilterArrOriginal.length : 0;

	const formatValue = (value) => value < 1 ? value.toFixed(2) : Math.round(value);

	const result = {
		_id: title,
		key: title,
		id: title,
		label: title,
		name: title,
		total: type === NUMBER_RANGE_TYPE.AVERAGE
			? formatValue(average)
			: formatValue(total),
		value: type === NUMBER_RANGE_TYPE.AVERAGE
			? formatValue(average)
			: formatValue(total),
		isSpacialItem: true,
		percentage: '',
		patientIds,
		isTooltip,
		...(isTooltip) && {
			originalTotal: type === NUMBER_RANGE_TYPE.AVERAGE
				? formatValue(averageOriginal)
				: formatValue(totalOriginal)
		},
		...(isADT && { type: ADT_TABLE_TYPE.CUSTOM }),
	};

	return result;
};

// Helper function to calculate totals for number ranges
const calculateTotalResponsesNumberRange = (patients, accessor, options, totalFilterData, item = null) => {
	const patientsData = getFilteredPatients(patients, accessor, item);
	const originalData = getFilteredPatients(totalFilterData?.originalData ?? [], accessor, item);
	const filteredIntermediateTotals = getFilteredIntermediateTotals(totalFilterData?.intermediateTotals, accessor, item);

	let isADT = totalFilterData?.isADT ?? false;
	const isOtherDashboard = totalFilterData?.isOtherDashboard ?? false;
	const isTooltip = totalFilterData?.totalType && totalFilterData?.totalType === TOTAL_TYPE.MAIN ? false : true;

	const currentLevel = totalFilterData?.currentLevel || 0;
	const cardTitles = totalFilterData?.cardTitles || {};

	// Helper function to filter patients by range
	const filterByRange = (patientList, min, max) => {
		if (min === ">") {
			return patientList?.filter((patient) => {
				const age = Number(patient[accessor]);
				return age > Number(max);
			}) || [];
		} else if (max === ">") {
			return patientList?.filter((patient) => {
				const age = Number(patient[accessor]);
				return age > Number(min);
			}) || [];
		} else {
			let minValue = Number(min);
			let maxValue = Number(max);
			if (minValue > maxValue) {
				[minValue, maxValue] = [maxValue, minValue];
			}
			return patientList?.filter((patient) => {
				const age = Number(patient[accessor]);
				return age >= minValue && age <= maxValue;
			}) || [];
		}
	};

	return options.map(({ min, max, type, title }) => {
		let patientsFilter = filterByRange(patientsData, min, max);
		let patientsFilterOriginal = isTooltip ? filterByRange(originalData, min, max) : [];

		// Calculate intermediate level totals
		let level1Total = 0;
		let level2Total = 0;
		let level3Total = 0;
		let level4Total = 0;
		let level5Total = 0;
		if (currentLevel >= 2 && Array.isArray(filteredIntermediateTotals?.level1)) {
			level1Total = filterByRange(filteredIntermediateTotals.level1, min, max).length;
		}
		if (currentLevel >= 3 && Array.isArray(filteredIntermediateTotals?.level2)) {
			level2Total = filterByRange(filteredIntermediateTotals.level2, min, max).length;
		}
		if (currentLevel >= 4 && Array.isArray(filteredIntermediateTotals?.level3)) {
			level3Total = filterByRange(filteredIntermediateTotals.level3, min, max).length;
		}
		if (currentLevel >= 5 && Array.isArray(filteredIntermediateTotals?.level4)) {
			level4Total = filterByRange(filteredIntermediateTotals.level4, min, max).length;
		}
		if (currentLevel >= 6 && Array.isArray(filteredIntermediateTotals?.level5)) {
			level5Total = filterByRange(filteredIntermediateTotals.level5, min, max).length;
		}

		const total = patientsFilter?.length || 0;
		const totalOriginal = patientsFilterOriginal?.length || 0;
		const label = title ? title : `${min} - ${max}`;
		const patientIds = patientsFilter?.length > 0 ? patientsFilter.map((item) => item._id) : [];
		const patientRefIds = patientsFilter?.length > 0 ? patientsFilter.map((item) => item.refPatientId) : [];
		const admissionIds = patientsFilter?.length > 0 ? patientsFilter.map((item) => item.admissionId) : [];
		let percentageTotal = totalFilterData?.totalForPercentage ? totalFilterData.totalForPercentage : patientsData?.length;

		if (type === NUMBER_RANGE_TYPE.TOTAL || type === NUMBER_RANGE_TYPE.AVERAGE) {
			return calculateTotalOrAverage(patientsData, accessor, type, title, isOtherDashboard ? patientRefIds : patientIds, isADT, totalFilterData, item);
		}

		return {
			_id: label,
			id: label,
			label,
			name: label,
			total,
			value: total,
			key: label,
			originalTotal: totalOriginal,
			percentage: itemPercentage(total, percentageTotal, "number"),
			patientIds: isOtherDashboard ? patientRefIds : patientIds,
			level: totalFilterData?.level || 0,
			isTooltip,
			...(currentLevel >= 2 && { level1Total }),
			...(currentLevel >= 3 && { level2Total }),
			...(currentLevel >= 4 && { level3Total }),
			...(currentLevel >= 5 && { level4Total }),
			...(currentLevel >= 6 && { level5Total }),
			...(currentLevel >= 2 && cardTitles?.level1 && { level1CardTitle: cardTitles.level1 }),
			...(currentLevel >= 3 && cardTitles?.level2 && { level2CardTitle: cardTitles.level2 }),
			...(currentLevel >= 4 && cardTitles?.level3 && { level3CardTitle: cardTitles.level3 }),
			...(currentLevel >= 5 && cardTitles?.level4 && { level4CardTitle: cardTitles.level4 }),
			...(currentLevel >= 6 && cardTitles?.level5 && { level5CardTitle: cardTitles.level5 }),
			...(isOtherDashboard || totalFilterData?.level > 0) && { otherDashboardIds: patientIds },
			...(isADT && { transferIds: patientIds }),
			...(isADT && { admissionIds: admissionIds }),
			...(isADT && { ids: patientIds }),
			...(isADT && { type: ADT_TABLE_TYPE.CUSTOM }),
		};
	});
};

// Helper function to normalize time to minutes for comparison
// Supports:
// - "HH:mm" (24h)
// - "HH:mm AM/PM" or "HH AM/PM"
// - ISO/date strings or Date objects (uses local time)
// - numeric minute values
const normalizeTime = (time) => {
	if (time === undefined || time === null) return NaN;

	// Date object or timestamp
	if (time instanceof Date || typeof time === 'number') {
		const date = time instanceof Date ? time : new Date(time);
		if (isNaN(date.getTime())) return NaN;
		return date.getHours() * 60 + date.getMinutes();
	}

	if (typeof time === 'string') {
		const trimmed = time.trim();

		// ISO or date-like string
		if (trimmed.includes('T') || trimmed.includes('-')) {
			const date = new Date(trimmed);
			if (!isNaN(date.getTime())) {
				return date.getHours() * 60 + date.getMinutes();
			}
		}

		// AM/PM handling
		const ampmMatch = trimmed.match(/^(\d{1,2})(?::(\d{2}))?\s*(AM|PM)$/i);
		if (ampmMatch) {
			let hours = parseInt(ampmMatch[1], 10);
			const minutes = parseInt(ampmMatch[2] ?? '0', 10);
			const meridiem = ampmMatch[3].toUpperCase();
			if (meridiem === 'PM' && hours !== 12) hours += 12;
			if (meridiem === 'AM' && hours === 12) hours = 0;
			return hours * 60 + minutes;
		}

		// 24h "HH:mm" or "HH" format fallback
		const timeStr = trimmed.includes(':') ? trimmed : `${trimmed}:00`;
		const [hoursStr, minutesStr] = timeStr.split(':');
		const hours = Number(hoursStr);
		const minutes = Number(minutesStr ?? 0);
		if (!Number.isNaN(hours) && !Number.isNaN(minutes)) {
			return hours * 60 + minutes;
		}
	}

	return NaN;
};

// Helper function to check if a time falls within a time range
const isTimeInRange = (patientTime, startTime, endTime) => {
	if (!patientTime) return false;

	const patientTimeMinutes = normalizeTime(patientTime);
	const startTimeMinutes = normalizeTime(startTime);
	const endTimeMinutes = normalizeTime(endTime);

	// Handle cases where end time is next day (e.g., 18:00 to 06:00)
	if (endTimeMinutes < startTimeMinutes) {
		return patientTimeMinutes >= startTimeMinutes || patientTimeMinutes <= endTimeMinutes;
	} else {
		return patientTimeMinutes >= startTimeMinutes && patientTimeMinutes < endTimeMinutes;
	}
};

const calculateTotalResponsesTimeRange = (patients, accessor, options, totalFilterData, timeRangeType, existingAccessor = null, item = null) => {
	const patientsData = getFilteredPatients(patients, existingAccessor || accessor, item);
	const originalData = getFilteredPatients(totalFilterData?.originalData ?? [], existingAccessor || accessor, item);
	const filteredIntermediateTotals = getFilteredIntermediateTotals(totalFilterData?.intermediateTotals, existingAccessor || accessor, item);

	let isADT = totalFilterData?.isADT ?? false;
	const isOtherDashboard = totalFilterData?.isOtherDashboard ?? false;
	const isTooltip = totalFilterData?.totalType && totalFilterData?.totalType === TOTAL_TYPE.MAIN ? false : true;

	const totalFilterDataForPercentage = totalFilterData?.totalFilterData ?? {};
	const currentLevel = totalFilterData?.currentLevel || 0;
	const cardTitles = totalFilterData?.cardTitles || {};

	let timeRanges = [];

	if (timeRangeType === TIME_RANGE_TYPE.HOURLY) {
		timeRanges = HOURLY_TIME_RANGES.map(hour => ({
			label: hour.label,
			startTime: hour.startTime || hour.value,
			endTime: hour.endTime || (hour.value === '23:00' ? '23:59' : HOURLY_TIME_RANGES.find(h => h.value === `${String(parseInt(hour.value.split(':')[0]) + 1).padStart(2, '0')}:00`)?.value || '00:00')
		}));
	} else {
		timeRanges = options || [];
	}

	// Use Promise.all to await all async operations
	return Promise.all(timeRanges.map(async (timeRange) => {
		const { label, startTime, endTime } = timeRange;

		let patientsFilter = patientsData?.filter((patient) =>
			isTimeInRange(patient[existingAccessor || accessor], startTime, endTime)
		) ?? [];

		// Intermediate level totals
		let level1Total = 0;
		let level2Total = 0;
		let level3Total = 0;
		let level4Total = 0;
		let level5Total = 0;
		if (currentLevel >= 2 && Array.isArray(filteredIntermediateTotals?.level1)) {
			level1Total = filteredIntermediateTotals.level1.filter((patient) =>
				isTimeInRange(patient[existingAccessor || accessor], startTime, endTime)
			).length;
		}
		if (currentLevel >= 3 && Array.isArray(filteredIntermediateTotals?.level2)) {
			level2Total = filteredIntermediateTotals.level2.filter((patient) =>
				isTimeInRange(patient[existingAccessor || accessor], startTime, endTime)
			).length;
		}
		if (currentLevel >= 4 && Array.isArray(filteredIntermediateTotals?.level3)) {
			level3Total = filteredIntermediateTotals.level3.filter((patient) =>
				isTimeInRange(patient[existingAccessor || accessor], startTime, endTime)
			).length;
		}
		if (currentLevel >= 5 && Array.isArray(filteredIntermediateTotals?.level4)) {
			level4Total = filteredIntermediateTotals.level4.filter((patient) =>
				isTimeInRange(patient[existingAccessor || accessor], startTime, endTime)
			).length;
		}
		if (currentLevel >= 6 && Array.isArray(filteredIntermediateTotals?.level5)) {
			level5Total = filteredIntermediateTotals.level5.filter((patient) =>
				isTimeInRange(patient[existingAccessor || accessor], startTime, endTime)
			).length;
		}

		const total = patientsFilter?.length || 0;
		const totalOriginal = originalData?.length > 0 ? originalData?.filter(patient =>
			isTimeInRange(patient?.[existingAccessor || accessor], startTime, endTime)
		)?.length : 0;
		const patientIds = patientsFilter?.length > 0 ? patientsFilter.map((item) => item._id) : [];
		const patientRefIds = patientsFilter?.length > 0 ? patientsFilter.map((item) => item.refPatientId) : [];
		const admissionIds = patientsFilter?.length > 0 ? patientsFilter.map((item) => item.admissionId) : [];
		let percentageTotal = totalFilterDataForPercentage?.totalForPercentage ? totalFilterDataForPercentage.totalForPercentage : patientsData?.length;

		return {
			_id: label,
			id: label,
			label,
			name: label,
			total,
			value: total,
			key: label,
			percentage: itemPercentage(total, percentageTotal, "number"),
			patientIds: isOtherDashboard ? patientRefIds : patientIds,
			level: totalFilterDataForPercentage?.level || 0,
			isTooltip,
			...(currentLevel >= 2 && { level1Total }),
			...(currentLevel >= 3 && { level2Total }),
			...(currentLevel >= 4 && { level3Total }),
			...(currentLevel >= 5 && { level4Total }),
			...(currentLevel >= 6 && { level5Total }),
			...(currentLevel >= 2 && cardTitles?.level1 && { level1CardTitle: cardTitles.level1 }),
			...(currentLevel >= 3 && cardTitles?.level2 && { level2CardTitle: cardTitles.level2 }),
			...(currentLevel >= 4 && cardTitles?.level3 && { level3CardTitle: cardTitles.level3 }),
			...(currentLevel >= 5 && cardTitles?.level4 && { level4CardTitle: cardTitles.level4 }),
			...(currentLevel >= 6 && cardTitles?.level5 && { level5CardTitle: cardTitles.level5 }),
			...(isTooltip) && { originalTotal: totalOriginal },
			...(isOtherDashboard || totalFilterDataForPercentage?.level > 0) && { otherDashboardIds: patientIds },
			...(isADT && { transferIds: patientIds }),
			...(isADT && { admissionIds: admissionIds }),
			...(isADT && { ids: patientIds }),
			...(isADT && { type: ADT_TABLE_TYPE.CUSTOM }),
		};
	}));
};

// Helper function to handle NUMBER_RANGE_LIMITED_ANSWERS
const calculateTotalRangeLimitedResponses = (patients, accessor, options, totalFilter, item = null) => {
	const numberRangeOptions = options.filter((opt) => opt.type === 'numberRange');
	const limitedAnswerOptions = options.filter((opt) => opt.type === 'limitedAnswers');
	const totalAndAverageOptions = options.filter((opt) => [NUMBER_RANGE_TYPE.TOTAL, NUMBER_RANGE_TYPE.AVERAGE].includes(opt.type));

	const results = calculateTotalResponsesNumberRange(patients, accessor, totalAndAverageOptions, totalFilter, item);

	const numberRangeResults = calculateTotalResponsesNumberRange(patients, accessor, numberRangeOptions, totalFilter, item);
	const limitedAnswerResults = calculateTotalResponses(
		patients,
		accessor,
		limitedAnswerOptions.map((opt) => opt.option),
		totalFilter,
		item
	);

	return [...numberRangeResults, ...limitedAnswerResults, ...results];
};

// Helper function to calculate date differences and count them in ranges
const calculateTotalResponsesDateAnalysis = (patients, accessor, options, totalFilterData, item) => {
	// Filter patients and intermediate totals based on invisible options
	const patientsData = getFilteredPatients(patients, accessor, item);
	const originalDataFiltered = getFilteredPatients(totalFilterData?.originalData ?? [], accessor, item);
	const filteredIntermediateTotals = getFilteredIntermediateTotals(totalFilterData?.intermediateTotals, accessor, item);

	let isADT = totalFilterData?.isADT ?? false;
	const isOtherDashboard = totalFilterData?.isOtherDashboard ?? false;
	const isTooltip = totalFilterData?.totalType && totalFilterData?.totalType === TOTAL_TYPE.MAIN ? false : true;

	const currentLevel = totalFilterData?.currentLevel || 0;
	const cardTitles = totalFilterData?.cardTitles || {};
	// Get start and end date question accessors from the item
	const { dateAnalysisStartQuestion, dateAnalysisEndQuestion } = item;

	// Ensure patients array exists, default to empty array
	const patientsArray = patientsData || [];
	const patientsArrayOriginal = isTooltip ? originalDataFiltered || [] : [];
	// If no date questions or no patients, return options with 0 values
	if (!dateAnalysisStartQuestion || !dateAnalysisEndQuestion || !patientsArray.length) {
		return options.map(({ min, max, type, title }, index) => {
			const label = type === NUMBER_RANGE_TYPE.TOTAL || type === NUMBER_RANGE_TYPE.AVERAGE
				? title
				: title ? title : `${min} - ${max} days`;

			return {
				_id: label,
				key: label,
				id: label,
				label,
				name: label,
				total: 0,
				value: 0,
				originalTotal: 0,
				percentage: '0',
				patientIds: [],
				level: totalFilterData?.level || 0,
				isTooltip,
				index: index,
				...(currentLevel >= 2 && { level1Total: 0 }),
				...(currentLevel >= 3 && { level2Total: 0 }),
				...(currentLevel >= 4 && { level3Total: 0 }),
				...(currentLevel >= 5 && { level4Total: 0 }),
				...(currentLevel >= 6 && { level5Total: 0 }),
				...(currentLevel >= 2 && cardTitles?.level1 && { level1CardTitle: cardTitles.level1 }),
				...(currentLevel >= 3 && cardTitles?.level2 && { level2CardTitle: cardTitles.level2 }),
				...(currentLevel >= 4 && cardTitles?.level3 && { level3CardTitle: cardTitles.level3 }),
				...(currentLevel >= 5 && cardTitles?.level4 && { level4CardTitle: cardTitles.level4 }),
				...(currentLevel >= 6 && cardTitles?.level5 && { level5CardTitle: cardTitles.level5 }),
				...(type === NUMBER_RANGE_TYPE.TOTAL || type === NUMBER_RANGE_TYPE.AVERAGE) && { isSpacialItem: true },
				...(isADT && { type: ADT_TABLE_TYPE.CUSTOM }),
				...(isADT && { transferIds: [] }),
				...(isADT && { admissionIds: [] }),
				...(isADT && { ids: [] }),
			};
		});
	}

	// Helper function to get the correct date value
	const getDateValue = (patient, dateField) => {
		if (dateField === "dateOfLatestAdmission") {
			return patient?.dateOfLatestAdmission || patient?.dateOfActualAdmission;
		}
		return patient[dateField];
	};

	const getDaysDiff = (patient) => {
		const startDate = getDateValue(patient, dateAnalysisStartQuestion);
		const endDate = getDateValue(patient, dateAnalysisEndQuestion);
		if (!startDate || !endDate) return null;
		const startDateMoment = moment.utc(startDate);
		const endDateMoment = moment.utc(endDate);
		if (!startDateMoment.isValid() || !endDateMoment.isValid()) return null;
		return startDateMoment.diff(endDateMoment, 'days');
	};

	// Process patients with valid date differences
	const patientsWithDateDiff = patientsArray.filter(patient => {
		const startDate = getDateValue(patient, dateAnalysisStartQuestion);
		const endDate = getDateValue(patient, dateAnalysisEndQuestion);
		return startDate && endDate;
	});
	let totalDaysOriginal = 0;
	let averageDaysOriginal = 0;
	let dateDifferencesOriginal = [];

	if (isTooltip) {
		const patientsWithDateDiffOriginal = patientsArrayOriginal.filter(patient => {
			const startDate = getDateValue(patient, dateAnalysisStartQuestion);
			const endDate = getDateValue(patient, dateAnalysisEndQuestion);
			return startDate && endDate;
		});

		dateDifferencesOriginal = patientsWithDateDiffOriginal.map(patient => {
			const startDateValue = getDateValue(patient, dateAnalysisStartQuestion);
			const endDateValue = getDateValue(patient, dateAnalysisEndQuestion);

			if (!startDateValue || !endDateValue) return null;

			const startDate = moment.utc(startDateValue);
			const endDate = moment.utc(endDateValue);

			if (!startDate.isValid() || !endDate.isValid()) return null;

			const daysDiff = startDate.diff(endDate, 'days');

			return {
				...patient,
				dateDifference: daysDiff
			};
		}).filter(Boolean); // Remove any null entries

		totalDaysOriginal = dateDifferencesOriginal.reduce((sum, patient) => {
			const value = Number(patient.dateDifference);
			return !isNaN(value) ? sum + value : sum;
		}, 0);

		averageDaysOriginal = dateDifferencesOriginal.length > 0 ? totalDaysOriginal / dateDifferencesOriginal.length : 0;
	}
	// Calculate date differences for all patients at once
	const dateDifferences = patientsWithDateDiff.map(patient => {
		const startDateValue = getDateValue(patient, dateAnalysisStartQuestion);
		const endDateValue = getDateValue(patient, dateAnalysisEndQuestion);

		if (!startDateValue || !endDateValue) return null;

		const startDate = moment.utc(startDateValue);
		const endDate = moment.utc(endDateValue);

		if (!startDate.isValid() || !endDate.isValid()) return null;

		const daysDiff = startDate.diff(endDate, 'days');

		return {
			...patient,
			dateDifference: daysDiff
		};
	}).filter(Boolean); // Remove any null entries

	// Calculate total and average once for all patients
	const totalDays = dateDifferences.reduce((sum, patient) => {
		const value = Number(patient.dateDifference);
		return !isNaN(value) ? sum + value : sum;
	}, 0);

	const averageDays = dateDifferences.length > 0 ? totalDays / dateDifferences.length : 0;
	const formatValue = (value) => value < 1 ? value.toFixed(2) : Math.round(value);

	return options.map(({ min, max, type, title }, index) => {
		if (type === NUMBER_RANGE_TYPE.TOTAL || type === NUMBER_RANGE_TYPE.AVERAGE) {
			const patientIds = dateDifferences.map(item => item._id) || [];
			const patientRefIds = dateDifferences.map(item => item.refPatientId) || [];
			return {
				_id: title,
				key: title,
				id: title,
				label: title,
				name: title,
				total: type === NUMBER_RANGE_TYPE.AVERAGE
					? formatValue(averageDays)
					: formatValue(totalDays),
				value: type === NUMBER_RANGE_TYPE.AVERAGE
					? formatValue(averageDays)
					: formatValue(totalDays),
				isSpacialItem: true,
				percentage: '',
				originalTotal: type === NUMBER_RANGE_TYPE.AVERAGE
					? formatValue(averageDaysOriginal)
					: formatValue(totalDaysOriginal),
				patientIds: isOtherDashboard ? patientRefIds : patientIds,
				isTooltip,
				index: index,
				...(currentLevel >= 2 && { level1Total: 0 }),
				...(currentLevel >= 3 && { level2Total: 0 }),
				...(isADT && { type: ADT_TABLE_TYPE.CUSTOM }),
			};
		} else {
			let patientsFilterOriginal = [];
			// Filter patients based on date difference ranges
			const patientsFilter = dateDifferences.filter(patient => {
				const daysDiff = patient.dateDifference;

				// Handle "and greater" operator in min field
				if (min === "and greater" || min === ">") {
					return daysDiff >= Number(max);
				}
				// Handle "and lower" operator in max field  
				else if (max === "and lower" || max === "<") {
					return daysDiff <= Number(min);
				}
				// Handle "and greater" operator in max field
				else if (max === "and greater" || max === ">") {
					return daysDiff >= Number(min);
				}
				// Handle "and lower" operator in min field
				else if (min === "and lower" || min === "<") {
					return daysDiff < Number(max);
				}
				// Default case: range between min and max
				else {
					let minValue = Number(min);
					let maxValue = Number(max);
					if (minValue > maxValue) {
						[minValue, maxValue] = [maxValue, minValue];
					}
					return daysDiff >= minValue && daysDiff <= maxValue;
				}
			});
			if (isTooltip) {
				patientsFilterOriginal = dateDifferencesOriginal.filter(patient => {
					const daysDiff = patient.dateDifference;

					// Handle "and greater" operator in min field
					if (min === "and greater" || min === ">") {
						return daysDiff >= Number(max);
					}
					// Handle "and lower" operator in max field  
					else if (max === "and lower" || max === "<") {
						return daysDiff <= Number(min);
					}
					// Handle "and greater" operator in max field
					else if (max === "and greater" || max === ">") {
						return daysDiff >= Number(min);
					}
					// Handle "and lower" operator in min field
					else if (min === "and lower" || min === "<") {
						return daysDiff < Number(max);
					}
					// Default case: range between min and max
					else {
						let minValue = Number(min);
						let maxValue = Number(max);
						if (minValue > maxValue) {
							[minValue, maxValue] = [maxValue, minValue];
						}
						return daysDiff >= minValue && daysDiff <= maxValue;
					}
				});
			}

			// Intermediate level totals
			let level1Total = 0;
			let level2Total = 0;
			let level3Total = 0;
			let level4Total = 0;
			let level5Total = 0;
			if (currentLevel >= 2 && Array.isArray(filteredIntermediateTotals?.level1)) {
				level1Total = filteredIntermediateTotals.level1.filter(patient => {
					const daysDiff = getDaysDiff(patient);
					if (daysDiff === null) return false;
					if (min === "and greater" || min === ">") return daysDiff >= Number(max);
					if (max === "and lower" || max === "<") return daysDiff <= Number(min);
					if (max === "and greater" || max === ">") return daysDiff >= Number(min);
					if (min === "and lower" || min === "<") return daysDiff < Number(max);
					let minValue = Number(min);
					let maxValue = Number(max);
					if (minValue > maxValue) {
						[minValue, maxValue] = [maxValue, minValue];
					}
					return daysDiff >= minValue && daysDiff <= maxValue;
				}).length;
			}
			if (currentLevel >= 3 && Array.isArray(filteredIntermediateTotals?.level2)) {
				level2Total = filteredIntermediateTotals.level2.filter(patient => {
					const daysDiff = getDaysDiff(patient);
					if (daysDiff === null) return false;
					if (min === "and greater" || min === ">") return daysDiff >= Number(max);
					if (max === "and lower" || max === "<") return daysDiff <= Number(min);
					if (max === "and greater" || max === ">") return daysDiff >= Number(min);
					if (min === "and lower" || min === "<") return daysDiff < Number(max);
					let minValue = Number(min);
					let maxValue = Number(max);
					if (minValue > maxValue) {
						[minValue, maxValue] = [maxValue, minValue];
					}
					return daysDiff >= minValue && daysDiff <= maxValue;
				}).length;
			}
			if (currentLevel >= 4 && Array.isArray(filteredIntermediateTotals?.level3)) {
				level3Total = filteredIntermediateTotals.level3.filter(patient => {
					const daysDiff = getDaysDiff(patient);
					if (daysDiff === null) return false;
					if (min === "and greater" || min === ">") return daysDiff >= Number(max);
					if (max === "and lower" || max === "<") return daysDiff <= Number(min);
					if (max === "and greater" || max === ">") return daysDiff >= Number(min);
					if (min === "and lower" || min === "<") return daysDiff < Number(max);
					let minValue = Number(min);
					let maxValue = Number(max);
					if (minValue > maxValue) {
						[minValue, maxValue] = [maxValue, minValue];
					}
					return daysDiff >= minValue && daysDiff <= maxValue;
				}).length;
			}
			if (currentLevel >= 5 && Array.isArray(filteredIntermediateTotals?.level4)) {
				level4Total = filteredIntermediateTotals.level4.filter(patient => {
					const daysDiff = getDaysDiff(patient);
					if (daysDiff === null) return false;
					if (min === "and greater" || min === ">") return daysDiff >= Number(max);
					if (max === "and lower" || max === "<") return daysDiff <= Number(min);
					if (max === "and greater" || max === ">") return daysDiff >= Number(min);
					if (min === "and lower" || min === "<") return daysDiff < Number(max);
					let minValue = Number(min);
					let maxValue = Number(max);
					if (minValue > maxValue) {
						[minValue, maxValue] = [maxValue, minValue];
					}
					return daysDiff >= minValue && daysDiff <= maxValue;
				}).length;
			}
			if (currentLevel >= 6 && Array.isArray(filteredIntermediateTotals?.level5)) {
				level5Total = filteredIntermediateTotals.level5.filter(patient => {
					const daysDiff = getDaysDiff(patient);
					if (daysDiff === null) return false;
					if (min === "and greater" || min === ">") return daysDiff >= Number(max);
					if (max === "and lower" || max === "<") return daysDiff <= Number(min);
					if (max === "and greater" || max === ">") return daysDiff >= Number(min);
					if (min === "and lower" || min === "<") return daysDiff < Number(max);
					let minValue = Number(min);
					let maxValue = Number(max);
					if (minValue > maxValue) {
						[minValue, maxValue] = [maxValue, minValue];
					}
					return daysDiff >= minValue && daysDiff <= maxValue;
				}).length;
			}

			const total = patientsFilter.length;

			const label = title ? title : `${min} - ${max} days`;
			const patientIds = patientsFilter.map(item => item._id);
			const patientRefIds = patientsFilter.map(item => item.refPatientId);
			const admissionIds = patientsFilter.map(item => item.admissionId);
			const percentageTotal = totalFilterData?.totalForPercentage || patientsArray.length;

			return {
				_id: label,
				id: label,
				label,
				name: label,
				total,
				value: total,
				key: label,
				percentage: itemPercentage(total, percentageTotal, "number"),
				patientIds: isOtherDashboard ? patientRefIds : patientIds,
				level: totalFilterData?.level || 0,
				isTooltip,
				...(currentLevel >= 2 && { level1Total }),
				...(currentLevel >= 3 && { level2Total }),
				...(currentLevel >= 4 && { level3Total }),
				...(currentLevel >= 5 && { level4Total }),
				...(currentLevel >= 6 && { level5Total }),
				...(currentLevel >= 2 && cardTitles?.level1 && { level1CardTitle: cardTitles.level1 }),
				...(currentLevel >= 3 && cardTitles?.level2 && { level2CardTitle: cardTitles.level2 }),
				...(currentLevel >= 4 && cardTitles?.level3 && { level3CardTitle: cardTitles.level3 }),
				...(currentLevel >= 5 && cardTitles?.level4 && { level4CardTitle: cardTitles.level4 }),
				...(currentLevel >= 6 && cardTitles?.level5 && { level5CardTitle: cardTitles.level5 }),
				...(isTooltip) && { originalTotal: patientsFilterOriginal.length },
				...(isOtherDashboard || totalFilterData?.level > 0) && { otherDashboardIds: patientIds },
				...(isADT && { transferIds: patientIds }),
				...(isADT && { admissionIds: admissionIds }),
				...(isADT && { ids: patientIds }),
				index: index,
				...(isADT && { type: ADT_TABLE_TYPE.CUSTOM }),
			};
		}
	});
};

const calculateTotalResponsesDateWithCardInDashboard = async (patients, accessor, options, totalFilterData, item) => {
	// Filter patients and intermediate totals based on invisible options
	const patientsData = getFilteredPatients(patients, accessor, item);
	const originalDataFiltered = getFilteredPatients(totalFilterData?.originalData ?? [], accessor, item);
	const filteredIntermediateTotals = getFilteredIntermediateTotals(totalFilterData?.intermediateTotals, accessor, item);

	let isADT = totalFilterData?.isADT ?? false;
	const isOtherDashboard = totalFilterData?.isOtherDashboard ?? false;
	const isTooltip = totalFilterData?.totalType && totalFilterData?.totalType === TOTAL_TYPE.MAIN ? false : true;

	const currentLevel = totalFilterData?.currentLevel || 0;
	const cardTitles = totalFilterData?.cardTitles || {};
	// Ensure patients array exists, default to empty array
	const patientsArray = patientsData || [];
	const patientsArrayOriginal = originalDataFiltered || [];

	// Helper function to get weekday options
	function getWeekdayOptions() {
		return [
			{ value: 0, label: 'Sunday' },
			{ value: 1, label: 'Monday' },
			{ value: 2, label: 'Tuesday' },
			{ value: 3, label: 'Wednesday' },
			{ value: 4, label: 'Thursday' },
			{ value: 5, label: 'Friday' },
			{ value: 6, label: 'Saturday' }
		];
	}

	const buildLevelCounts = (snapshot = []) => {
		const counts = {};
		snapshot.forEach(patient => {
			const dateValue = patient[accessor];
			if (dateValue) {
				const date = moment.utc(dateValue);
				if (date.isValid()) {
					const weekday = date.day();
					counts[weekday] = (counts[weekday] || 0) + 1;
				}
			}
		});
		return counts;
	};

	const level1Counts = currentLevel >= 2 ? buildLevelCounts(filteredIntermediateTotals?.level1 || []) : {};
	const level2Counts = currentLevel >= 3 ? buildLevelCounts(filteredIntermediateTotals?.level2 || []) : {};
	const level3Counts = currentLevel >= 4 ? buildLevelCounts(filteredIntermediateTotals?.level3 || []) : {};
	const level4Counts = currentLevel >= 5 ? buildLevelCounts(filteredIntermediateTotals?.level4 || []) : {};
	const level5Counts = currentLevel >= 6 ? buildLevelCounts(filteredIntermediateTotals?.level5 || []) : {};

	// If no accessor or no patients, return weekday options with 0 values (still include level totals)
	if (!accessor || !patientsArray.length) {
		return getWeekdayOptions().map(({ value, label }) => ({
			_id: value,
			key: value,
			id: value,
			label,
			name: label,
			total: 0,
			value: 0,
			originalTotal: 0,
			percentage: '0',
			patientIds: [],
			level: totalFilterData?.level || 0,
			isTooltip,
			...(currentLevel >= 2 && { level1Total: level1Counts[value] || 0 }),
			...(currentLevel >= 3 && { level2Total: level2Counts[value] || 0 }),
			...(currentLevel >= 4 && { level3Total: level3Counts[value] || 0 }),
			...(currentLevel >= 5 && { level4Total: level4Counts[value] || 0 }),
			...(currentLevel >= 6 && { level5Total: level5Counts[value] || 0 }),
			...(currentLevel >= 2 && cardTitles?.level1 && { level1CardTitle: cardTitles.level1 }),
			...(currentLevel >= 3 && cardTitles?.level2 && { level2CardTitle: cardTitles.level2 }),
			...(currentLevel >= 4 && cardTitles?.level3 && { level3CardTitle: cardTitles.level3 }),
			...(currentLevel >= 5 && cardTitles?.level4 && { level4CardTitle: cardTitles.level4 }),
			...(currentLevel >= 6 && cardTitles?.level5 && { level5CardTitle: cardTitles.level5 }),
			...(isTooltip) && { originalTotal: 0 },
			...(isADT && { type: ADT_TABLE_TYPE.CUSTOM }),
			...(isADT && { transferIds: [] }),
			...(isADT && { admissionIds: [] }),
			...(isADT && { ids: [] }),
		}));
	}

	// Process patients and group by weekday
	const patientsByWeekday = {};
	const patientsByWeekdayOriginal = {};
	// Initialize weekday groups
	getWeekdayOptions().forEach(({ value }) => {
		patientsByWeekday[value] = [];
	});

	getWeekdayOptions().forEach(({ value }) => {
		patientsByWeekdayOriginal[value] = [];
	});


	// Filter and group patients by the weekday of their date
	patientsArray.forEach(patient => {
		const dateValue = patient[accessor];

		if (dateValue) {
			const date = moment.utc(dateValue);

			if (date.isValid()) {
				const weekday = date.day(); // 0 = Sunday, 1 = Monday, etc.
				patientsByWeekday[weekday].push(patient);
			}
		}
	});

	if (isTooltip) {
		patientsArrayOriginal.forEach(patient => {
			const dateValue = patient[accessor];
			if (dateValue) {
				const date = moment.utc(dateValue);
				if (date.isValid()) {
					const weekday = date.day();
					patientsByWeekdayOriginal[weekday].push(patient);
				}
			}
		});
	}

	// Calculate total for percentage
	const totalPatientsWithValidDate = Object.values(patientsByWeekday)
		.reduce((sum, dayPatients) => sum + dayPatients.length, 0);

	const percentageTotal = totalFilterData?.totalForPercentage || totalPatientsWithValidDate;


	// Return data for each weekday
	return getWeekdayOptions().map(({ value, label }) => {
		const dayPatients = patientsByWeekday[value] || [];
		const dayPatientsOriginal = isTooltip ? patientsByWeekdayOriginal[value] || [] : [];
		const total = dayPatients.length;
		const totalOriginal = dayPatientsOriginal.length;
		const patientIds = dayPatients.map(item => item._id);
		const patientRefIds = dayPatients.map(item => item.refPatientId);
		const admissionIds = dayPatients.map(item => item.admissionId);
		return {
			_id: value,
			key: value,
			id: value,
			label,
			name: label,
			total,
			value: total,
			originalTotal: totalOriginal,
			percentage: itemPercentage(total, percentageTotal, "number"),
			patientIds: isOtherDashboard ? patientRefIds : patientIds,
			level: totalFilterData?.level || 0,
			isTooltip,
			...(currentLevel >= 2 && { level1Total: level1Counts[value] || 0 }),
			...(currentLevel >= 3 && { level2Total: level2Counts[value] || 0 }),
			...(currentLevel >= 4 && { level3Total: level3Counts[value] || 0 }),
			...(currentLevel >= 5 && { level4Total: level4Counts[value] || 0 }),
			...(currentLevel >= 6 && { level5Total: level5Counts[value] || 0 }),
			...(currentLevel >= 2 && cardTitles?.level1 && { level1CardTitle: cardTitles.level1 }),
			...(currentLevel >= 3 && cardTitles?.level2 && { level2CardTitle: cardTitles.level2 }),
			...(currentLevel >= 4 && cardTitles?.level3 && { level3CardTitle: cardTitles.level3 }),
			...(currentLevel >= 5 && cardTitles?.level4 && { level4CardTitle: cardTitles.level4 }),
			...(currentLevel >= 6 && cardTitles?.level5 && { level5CardTitle: cardTitles.level5 }),
			...(isTooltip) && { originalTotal: totalOriginal },
			...(isOtherDashboard || totalFilterData?.level > 0) && { otherDashboardIds: patientIds },
			...(isADT && { transferIds: patientIds }),
			...(isADT && { admissionIds: admissionIds }),
			...(isADT && { ids: patientIds }),
			...(isADT && { type: ADT_TABLE_TYPE.CUSTOM }),
		};
	});
};

export async function processDynamicCard(item, patientFilterData, objectCustomRes, totalFilterData) {
	const { customQuestionInputType, accessor, validationOptions, customQuestionOptions = [], timeRangeType, existingAccessor } = item;

	switch (customQuestionInputType) {
		case QUESTION_INPUT_TYPE.UNLIMITED_ANSWERS:
			objectCustomRes[accessor] = calculateTotalResponses(patientFilterData, accessor, validationOptions, { ...totalFilterData, totalType: QUESTION_INPUT_TYPE.UNLIMITED_ANSWERS, isSort: true }, item);
			break;

		case QUESTION_INPUT_TYPE.LIMITED_ANSWERS:
			objectCustomRes[accessor] = calculateTotalResponses(patientFilterData, accessor, customQuestionOptions, { ...totalFilterData, isSort: true }, item);
			break;

		case QUESTION_INPUT_TYPE.NUMBER_RANGE:
			objectCustomRes[accessor] = calculateTotalResponsesNumberRange(patientFilterData, accessor, customQuestionOptions, totalFilterData, item);
			break;

		case QUESTION_INPUT_TYPE.TIME_TAB_RANGE:
			objectCustomRes[accessor] = await calculateTotalResponsesTimeRange(patientFilterData, accessor, customQuestionOptions, totalFilterData, timeRangeType, existingAccessor, item);
			break;

		case QUESTION_INPUT_TYPE.NUMBER_RANGE_LIMITED_ANSWERS:
			objectCustomRes[accessor] = calculateTotalRangeLimitedResponses(patientFilterData, accessor, customQuestionOptions, totalFilterData, item);
			break;

		case QUESTION_INPUT_TYPE.DATE_ANALYSIS:
			objectCustomRes[accessor] = calculateTotalResponsesDateAnalysis(patientFilterData, accessor, customQuestionOptions, totalFilterData, item);
			break;

		case QUESTION_INPUT_TYPE.DATE:
			objectCustomRes[accessor] = await calculateTotalResponsesDateWithCardInDashboard(patientFilterData, accessor, customQuestionOptions, totalFilterData, item);
			break;

		default:
			break;
	}
}

export function filterDynamicQuestions(allDynamicCards, optionId) {

	let dynamicQuestion = [];

	if (optionId === PAGE_TYPE.HOSPITAL) {
		dynamicQuestion = _.filter(allDynamicCards, {
			forType: 'transfer',
			forTransferType: 'hospitalTransfer',
		});
	} else if (optionId === PAGE_TYPE.COMMUNITY_TRANSFER) {
		const validTransferTypes = [
			ADT_SUB_TYPES.AMA,
			ADT_SUB_TYPES.SAFE_DISCHARGE,
			ADT_SUB_TYPES.SNF,
			ADT_SUB_TYPES.TOTAL_COMMUNITY,
		];
		dynamicQuestion = _.filter(allDynamicCards, (ele) =>
			ele.forType === 'transfer' && _.includes(validTransferTypes, ele.forTransferType)
		);
	} else if (optionId === PAGE_TYPE.DECEASED) {
		dynamicQuestion = _.filter(allDynamicCards, {
			forType: 'transfer',
			forTransferType: 'deceased',
		});
	}

	return dynamicQuestion;
}

export async function dynamicCardFilter(patientFilterData, dynamicCards, totalFilterData) {
	const objectCustomRes = {};
	for (const item of dynamicCards) {
		await processDynamicCard(item, patientFilterData, objectCustomRes, totalFilterData);
	}
	return objectCustomRes;
}

export const validateQuestionValues = (values) => {
	const errors = {};

	if (!values.label) {
		errors.label = 'Label is required.';
	}

	if (!values.customQuestionInputType) {
		errors.customQuestionInputType = 'Input type is required.';
	}

	if (values.invisibleAnswerOptions && !values.dataInputLabel) {
		errors.dataInputLabel = 'Label for data input is required when invisible answer options are enabled.';
	}

	const shouldCheckOptions = [
		QUESTION_INPUT_TYPE.LIMITED_ANSWERS,
		QUESTION_INPUT_TYPE.NUMBER_RANGE,
		QUESTION_INPUT_TYPE.NUMBER_RANGE_LIMITED_ANSWERS,
		QUESTION_INPUT_TYPE.TIME_TAB_RANGE,
		QUESTION_INPUT_TYPE.DATE_ANALYSIS,
	].includes(values.customQuestionInputType);

	if (shouldCheckOptions) {
		if (
			values.customQuestionInputType === QUESTION_INPUT_TYPE.TIME_TAB_RANGE &&
			values.timeRangeType === 'hourly'
		) {
			// No validation needed for hourly mode
		} else if (values.customQuestionInputType === QUESTION_INPUT_TYPE.TIME_TAB_RANGE && values.timeRangeType === 'custom' && (!values.customQuestionOptions || values.customQuestionOptions.length === 0)) {
			errors.customQuestionOptions = 'Options are required.';
		} else {
			if (values.customQuestionInputType === QUESTION_INPUT_TYPE.LIMITED_ANSWERS) {
				if (!Array.isArray(values.customQuestionOptions)) {
					errors.customQuestionOptions = 'Options must be an array.';
				} else if (values.customQuestionOptions.every(option => !option)) {
					errors.customQuestionOptions = 'Options must contain at least one valid option.';
				}
			} else if (values.customQuestionInputType === QUESTION_INPUT_TYPE.TIME_TAB_RANGE) {
				if (values.timeRangeType === 'custom') {
					if (!Array.isArray(values.customQuestionOptions)) {
						errors.customQuestionOptions = 'Time ranges must be an array.';
					} else {
						values.customQuestionOptions.forEach((range, index) => {
							if (!range.label) {
								if (!errors.customQuestionOptions) errors.customQuestionOptions = [];
								if (!errors.customQuestionOptions[index]) errors.customQuestionOptions[index] = {};
								errors.customQuestionOptions[index].label = 'Range label is required.';
							}
							if (!range.startTime) {
								if (!errors.customQuestionOptions) errors.customQuestionOptions = [];
								if (!errors.customQuestionOptions[index]) errors.customQuestionOptions[index] = {};
								errors.customQuestionOptions[index].startTime = 'Start time is required.';
							}
							if (!range.endTime) {
								if (!errors.customQuestionOptions) errors.customQuestionOptions = [];
								if (!errors.customQuestionOptions[index]) errors.customQuestionOptions[index] = {};
								errors.customQuestionOptions[index].endTime = 'End time is required.';
							}
						});
					}
				}
			} else if (values.customQuestionInputType === QUESTION_INPUT_TYPE.NUMBER_RANGE) {
				if (!Array.isArray(values.customQuestionOptions)) {
					errors.customQuestionOptions = 'Range must be an array.';
				} else {
					values.customQuestionOptions.forEach((range, index) => {
						const isMinSymbol = typeof range.min === 'string' && (range.min.includes('<') || range.min.includes('>'));
						const isMaxSymbol = typeof range.max === 'string' && (range.max.includes('<') || range.max.includes('>'));
						const isMinNumber = !isNaN(range.min) && range.min !== '';
						const isMaxNumber = !isNaN(range.max) && range.max !== '';

						if (range.type === NUMBER_RANGE_TYPE.TOTAL || range.type === NUMBER_RANGE_TYPE.AVERAGE) {
							if (range.title === undefined || range.title === '') {
								if (!errors.customQuestionOptions) errors.customQuestionOptions = [];
								if (!errors.customQuestionOptions[index]) errors.customQuestionOptions[index] = {};
								errors.customQuestionOptions[index].title = `${range.type} Title is required.`;
							}
						} else {
							if (range.min === undefined || range.min === '') {
								if (!errors.customQuestionOptions) errors.customQuestionOptions = [];
								if (!errors.customQuestionOptions[index]) errors.customQuestionOptions[index] = {};
								errors.customQuestionOptions[index].min = 'Min value is required.';
							}

							if (range.max === undefined || range.max === '') {
								if (!errors.customQuestionOptions) errors.customQuestionOptions = [];
								if (!errors.customQuestionOptions[index]) errors.customQuestionOptions[index] = {};
								errors.customQuestionOptions[index].max = 'Max value is required.';
							}

							if (isMinSymbol && isMaxSymbol) {
								if (!errors.customQuestionOptions) errors.customQuestionOptions = [];
								if (!errors.customQuestionOptions[index]) errors.customQuestionOptions[index] = {};
								errors.customQuestionOptions[index].min = 'Min and Max cannot both be symbols.';
								errors.customQuestionOptions[index].max = 'Min and Max cannot both be symbols.';
							}

							if (isMinNumber && isMaxNumber) {
								if (Number(range.min) > Number(range.max)) {
									if (!errors.customQuestionOptions) errors.customQuestionOptions = [];
									if (!errors.customQuestionOptions[index]) errors.customQuestionOptions[index] = {};
									errors.customQuestionOptions[index].min = 'Min value must be less than or equal to Max value.';
									errors.customQuestionOptions[index].max = 'Max value must be greater than or equal to Min value.';
								}
							}
						}
					});
				}
			} else if (values.customQuestionInputType === QUESTION_INPUT_TYPE.NUMBER_RANGE_LIMITED_ANSWERS) {
				if (!Array.isArray(values.customQuestionOptions)) {
					errors.customQuestionOptions = 'Range or option must be an array.';
				} else {
					const hasRange = values.customQuestionOptions.some(item => typeof item === 'object' && item !== null && item.type === 'numberRange' && (item.min !== null && item.min !== undefined && item.min !== '') && (item.max !== null && item.max !== undefined && item.max !== ''));
					const hasLimitedAnswers = values.customQuestionOptions.some(item => typeof item === 'object' && item !== null && item.type === 'limitedAnswers' && (item.option !== null && item.option !== undefined && item.option !== ''));

					if (!hasRange && !hasLimitedAnswers) {
						errors.customQuestionOptions = 'Must contain at least one range or one limited answer.';
					} else {

						values.customQuestionOptions.forEach((option, index) => {
							if (typeof option === 'object' && option !== null) {

								if ([NUMBER_RANGE_TYPE.TOTAL, NUMBER_RANGE_TYPE.AVERAGE].includes(option.type)) {
									if (!option.title) {
										errors.customQuestionOptions = errors.customQuestionOptions || [];
										errors.customQuestionOptions[index] = errors.customQuestionOptions[index] || {};
										errors.customQuestionOptions[index].title = `${option.type} Title is required.`;
									}
								}

								if (option.type === 'numberRange') {
									const isMinSymbol = typeof option.min === 'string' && (option.min.includes('<') || option.min.includes('>'));
									const isMaxSymbol = typeof option.max === 'string' && (option.max.includes('<') || option.max.includes('>'));
									const isMinNumber = !isNaN(option.min) && option.min !== '';
									const isMaxNumber = !isNaN(option.max) && option.max !== '';

									if (option.min === undefined || option.min === '') {
										if (!errors.customQuestionOptions) errors.customQuestionOptions = [];
										if (!errors.customQuestionOptions[index]) errors.customQuestionOptions[index] = {};
										errors.customQuestionOptions[index].min = 'Min value is required.';
									}

									if (option.max === undefined || option.max === '') {
										if (!errors.customQuestionOptions) errors.customQuestionOptions = [];
										if (!errors.customQuestionOptions[index]) errors.customQuestionOptions[index] = {};
										errors.customQuestionOptions[index].max = 'Max value is required.';
									}

									if (isMinSymbol && isMaxSymbol) {
										if (!errors.customQuestionOptions) errors.customQuestionOptions = [];
										if (!errors.customQuestionOptions[index]) errors.customQuestionOptions[index] = {};
										errors.customQuestionOptions[index].min = 'Min and Max cannot both be symbols.';
										errors.customQuestionOptions[index].max = 'Min and Max cannot both be symbols.';
									}

									if (isMinNumber && isMaxNumber) {
										if (Number(option.min) > Number(option.max)) {
											if (!errors.customQuestionOptions) errors.customQuestionOptions = [];
											if (!errors.customQuestionOptions[index]) errors.customQuestionOptions[index] = {};
											errors.customQuestionOptions[index].min = 'Min value must be less than or equal to Max value.';
											errors.customQuestionOptions[index].max = 'Max value must be greater than or equal to Min value.';
										}
									}
								} else if (option.type === 'limitedAnswers') {
									if (!option.option) {
										if (!errors.customQuestionOptions) errors.customQuestionOptions = [];
										if (!errors.customQuestionOptions[index]) errors.customQuestionOptions[index] = {};
										errors.customQuestionOptions[index].option = 'Option is required.';
									}
								}
							}
						});
					}
				}
			} else if (values.customQuestionInputType === QUESTION_INPUT_TYPE.DATE_ANALYSIS) {
				// Validate date analysis specific fields
				if (!values.dateAnalysisStartQuestion) {
					errors.dateAnalysisStartQuestion = 'Start date question is required.';
				}
				if (!values.dateAnalysisEndQuestion) {
					errors.dateAnalysisEndQuestion = 'End date question is required.';
				}
				if (values.dateAnalysisStartQuestion === values.dateAnalysisEndQuestion) {
					errors.dateAnalysisEndQuestion = 'End date question must be different from start date question.';
				}

				// Validate analysis options (same as NUMBER_RANGE)
				if (!Array.isArray(values.customQuestionOptions)) {
					errors.customQuestionOptions = 'Analysis options must be an array.';
				} else if (!values.customQuestionOptions || values.customQuestionOptions.length === 0) {
					errors.customQuestionOptions = 'Analysis options must be an array.';
				} else {
					values.customQuestionOptions.forEach((range, index) => {
						const isMinSymbol = typeof range.min === 'string' && (range.min.includes('<') || range.min.includes('>'));
						const isMaxSymbol = typeof range.max === 'string' && (range.max.includes('<') || range.max.includes('>'));
						const isMinNumber = !isNaN(range.min) && range.min !== '';
						const isMaxNumber = !isNaN(range.max) && range.max !== '';

						if (range.type === NUMBER_RANGE_TYPE.TOTAL || range.type === NUMBER_RANGE_TYPE.AVERAGE) {
							if (range.title === undefined || range.title === '') {
								if (!errors.customQuestionOptions) errors.customQuestionOptions = [];
								if (!errors.customQuestionOptions[index]) errors.customQuestionOptions[index] = {};
								errors.customQuestionOptions[index].title = `${range.type} Title is required.`;
							}
						} else {
							if (range.min === undefined || range.min === '') {
								if (!errors.customQuestionOptions) errors.customQuestionOptions = [];
								if (!errors.customQuestionOptions[index]) errors.customQuestionOptions[index] = {};
								errors.customQuestionOptions[index].min = 'Min value is required.';
							}

							if (range.max === undefined || range.max === '') {
								if (!errors.customQuestionOptions) errors.customQuestionOptions = [];
								if (!errors.customQuestionOptions[index]) errors.customQuestionOptions[index] = {};
								errors.customQuestionOptions[index].max = 'Max value is required.';
							}

							if (isMinSymbol && isMaxSymbol) {
								if (!errors.customQuestionOptions) errors.customQuestionOptions = [];
								if (!errors.customQuestionOptions[index]) errors.customQuestionOptions[index] = {};
								errors.customQuestionOptions[index].min = 'Min and Max cannot both be symbols.';
								errors.customQuestionOptions[index].max = 'Min and Max cannot both be symbols.';
							}

							if (isMinNumber && isMaxNumber) {
								if (Number(range.min) > Number(range.max)) {
									if (!errors.customQuestionOptions) errors.customQuestionOptions = [];
									if (!errors.customQuestionOptions[index]) errors.customQuestionOptions[index] = {};
									errors.customQuestionOptions[index].min = 'Min value must be less than or equal to Max value.';
									errors.customQuestionOptions[index].max = 'Max value must be greater than or equal to Min value.';
								}
							}
						}
					});
				}
			}
		}
	}
	return errors;
};

export const updateChartFilterByPriority = (cardFilter, type) => {
	if (!cardFilter || !Array.isArray(cardFilter.priorityData)) {
		return { ...cardFilter };
	}

	let latestCardFilter = { ...cardFilter };
	const selectedPriority = _.find(cardFilter.priorityData, { type });

	if (selectedPriority) {
		const idx = cardFilter.priorityData.findIndex((elem) => elem.type === type);

		if (idx !== -1) {
			let selectedFilters = [];
			if (cardFilter.priorityData.length > 1 && idx > 0) {
				const selectedCardPriority = cardFilter.priorityData.slice(0, idx);
				selectedFilters = _.map(selectedCardPriority, "type");
			}
			const updatedFilter = {};
			for (const [key, value] of Object.entries(cardFilter)) {
				if (key === "priorityData") {
					updatedFilter[key] = cardFilter.priorityData;
				} else if (_.includes(selectedFilters, key)) {
					updatedFilter[key] = value;
				} else {
					updatedFilter[key] = [];
				}
			}
			latestCardFilter = updatedFilter;
		}
	}

	return latestCardFilter;
};

export const ADTpriorityFilter = async (priorityDataFilter, childId, cardId, latestAdmitFilters = []) => {
	const selectedFilter = _.find(latestAdmitFilters, { childId, cardId });

	const totalChecked = selectedFilter?.selectedIds?.length || 0;
	let priorityData = [];
	const selectedPriority = _.find(priorityDataFilter, { childId, cardId });
	if (selectedPriority) {
		const idx = priorityDataFilter.findIndex((p) => p.childId === childId && p.cardId === cardId);

		if (totalChecked > 0) {
			priorityData = update(priorityDataFilter, {
				[idx]: { $set: selectedFilter },
			});
		} else {
			priorityData = update(priorityDataFilter, {
				$splice: [[idx, 1]],
			});
		}
	} else {
		if (totalChecked > 0) {
			priorityData = update(priorityDataFilter, { $push: [selectedFilter] });
		}
	}
	return priorityData;
};

export const priorityFilterOld = async (priorityDataFilter, type, totalChecked, cardTitle, question, patientIds, isRemoveIds) => {
	let priorityData = [];
	const selectedPriority = _.find(priorityDataFilter, { type });
	if (selectedPriority) {
		const idx = priorityDataFilter.findIndex((p) => p.type === type);
		if (totalChecked > 0) {
			let priObject = { type, priority: 1, selectedChk: totalChecked, cardTitle };
			priorityData = update(priorityDataFilter, { [idx]: { $set: priObject } });
		} else {
			priorityData = update(priorityDataFilter, {
				$splice: [[idx, 1]],
			});
		}
	} else {
		if (totalChecked > 0) {
			let priObject = { type, priority: 1, selectedChk: totalChecked, cardTitle };
			priorityData = update(priorityDataFilter, { $push: [priObject] });
		}
	}
	return priorityData;
};

export const priorityFilter = async (priorityDataFilter, type, totalChecked, cardTitle, question, patientIds, isRemoveIds, newChecked, isReplaceIds = false) => {

	let priorityData = [];
	const selectedPriority = _.find(priorityDataFilter, { type });
	if (selectedPriority) {
		const idx = priorityDataFilter.findIndex((p) => p.type === type);
		if (totalChecked > 0) {
			let priObject = {
				type,
				priority: 1,
				selectedChk: totalChecked,
				cardTitle,
				...(question !== undefined && question !== null && { question }),
				selectedItems: newChecked || [],
			};

			if (patientIds) {
				if (isReplaceIds) {
					// Directly replace patientIds (used when recalculating from multiple composite keys)
					priObject.patientIds = patientIds;
				} else if (isRemoveIds) {
					priObject.patientIds = _.difference(selectedPriority.patientIds || [], patientIds);
				} else {
					priObject.patientIds = _.union(selectedPriority.patientIds || [], patientIds);
				}
			} else {
				priObject.patientIds = selectedPriority.patientIds;
			}

			priorityData = update(priorityDataFilter, { [idx]: { $set: priObject } });
		} else {
			priorityData = update(priorityDataFilter, {
				$splice: [[idx, 1]],
			});
		}
	} else {
		if (totalChecked > 0) {
			let priObject = {
				type,
				priority: 1,
				selectedChk: totalChecked,
				cardTitle,
				...(question !== undefined && question !== null && { question }),
				patientIds: patientIds || [],
				selectedItems: newChecked || [],
			};
			priorityData = update(priorityDataFilter, { $push: [priObject] });
		}
	}
	return priorityData;
};

export const admissionPriorityFilter = async (
	priorityDataFilter,
	cardFilterPart,
	existingFilters,
	filterType,
	cardTitle = null,
	question,
	patientIds,
	isRemoveIds,
	newChecked,
	isReplaceIds = false
) => {
	let priorityData = [];
	if (cardFilterPart && cardFilterPart.type) {
		let type = cardFilterPart.type;
		const selectedPriority = _.find(priorityDataFilter, { type });
		if (selectedPriority) {
			const idx = priorityDataFilter.findIndex((p) => p.type === type);
			if (existingFilters > 0) {
				let priObject = {
					type,
					priority: 1,
					selectedChk: existingFilters,
					filterType,
					cardTitle,
					selectedItems: newChecked || [],
					...(question !== undefined && question !== null && { question }),
				};
				if (patientIds) {
					if (isReplaceIds) {
						priObject.patientIds = patientIds;
					} else if (isRemoveIds) {
						priObject.patientIds = _.difference(selectedPriority.patientIds || [], patientIds);
					} else {
						priObject.patientIds = _.union(selectedPriority.patientIds || [], patientIds);
					}
				} else {
					priObject.patientIds = selectedPriority.patientIds;
				}
				priorityData = update(priorityDataFilter, {
					[idx]: { $set: priObject },
				});
			} else {
				priorityData = update(priorityDataFilter, {
					$splice: [[idx, 1]],
				});
			}
		} else {
			if (existingFilters > 0) {
				let priObject = {
					type,
					priority: 1,
					selectedChk: existingFilters,
					filterType,
					cardTitle,
					patientIds: patientIds || [],
					selectedItems: newChecked || [],
					...(question !== undefined && question !== null && { question }),
				};
				priorityData = update(priorityDataFilter, { $push: [priObject] });
			}
		}
	} else {
		let childId = cardFilterPart.childId;
		let cardId = cardFilterPart.cardId;
		let latestAdmitFilters = existingFilters;
		let selectedFilter = _.find(latestAdmitFilters, { childId, cardId });
		if (selectedFilter) {
			selectedFilter = Object.assign({}, selectedFilter, { filterType });
		}
		const totalChecked = selectedFilter?.selectedIds?.length || 0;
		const selectedPriority = _.find(priorityDataFilter, { childId, cardId });
		if (selectedPriority) {
			const idx = priorityDataFilter.findIndex((p) => p.childId === childId && p.cardId === cardId);
			if (totalChecked > 0) {
				priorityData = update(priorityDataFilter, {
					[idx]: { $set: selectedFilter },
				});
			} else {
				priorityData = update(priorityDataFilter, {
					$splice: [[idx, 1]],
				});
			}
		} else {
			if (totalChecked > 0) {
				priorityData = update(priorityDataFilter, { $push: [selectedFilter] });
			}
		}
	}
	return priorityData;
};

export function projectionPerMonth(total, filter, projectionDays = 30) {
	let projections = 0;
	const { startDate, endDate } = filter;
	var a = moment.utc(startDate).startOf("day");
	var b = moment.utc(endDate).endOf("day");
	let days = b.diff(a, "days") + 1;
	//days = days === 0 ? 1 : (days + 1);
	if (days <= 30) {
		//projectionDays = 30
		projections = (projectionDays * total) / days;
	} else {
		//projectionDays = 30
		const months = days / projectionDays;
		projections = total / months;
	}
	return projections ? Math.round(projections) : 0;
}

export function itemPercentageChart(total, mainTotalVal = null) {
	let percentage = 0;
	if (total !== 0 && mainTotalVal !== 0) {
		percentage = (total / mainTotalVal) * 100;
	}
	percentage = percentage ? percentage : 0;

	return `${percentage.toFixed(2)}%`;
}

export function itemPercentage(total, mainTotalVal = null, type, page = "hospital", forComparison) {
	let selectedTotal = 0;
	if (!mainTotalVal) {
		if (page === PAGE_TYPE.HOSPITAL) {
			const { mainTotal } = store.getState().hospital;
			selectedTotal = mainTotal;
		}
		if (page === PAGE_TYPE.ADMISSION) {
			const { mainTotal } = store.getState().admission;
			selectedTotal = mainTotal;
		}
		if (page === PAGE_TYPE.COMMUNITY_TRANSFER) {
			const { mainTotal } = store.getState().communityTransfer;
			selectedTotal = mainTotal;
		}
		if (page === PAGE_TYPE.DECEASED) {
			const { mainTotal } = store.getState().deceased;
			selectedTotal = mainTotal;
		}
		if (page === PAGE_TYPE.OVERALL) {
			const { mainTotal } = store.getState().overall;
			selectedTotal = mainTotal;
		}
	} else {
		selectedTotal = mainTotalVal;
	}
	let percentage = 0;

	if (forComparison && total === mainTotalVal) {
		percentage = 0;
	} else if (total !== 0 && selectedTotal !== 0) {
		percentage = (total / selectedTotal) * 100;
	}
	percentage = percentage ? percentage : 0;
	if (type && type === "number") {
		return percentage < 1 ? percentage.toFixed(1) : percentage.toFixed();
	}
	if (type && type === "percentage") {
		return `${percentage.toFixed()}%`;
	}
	return `(${percentage.toFixed()}%)`;
}

export function matchedArray(array1, array2) {
	return _.intersectionWith(array1, array2, _.isEqual);
}

export function getMatchedId(array1, array2) {
	let resArr = [];
	_.intersectionWith(array1, array2, (a, b) => {
		if (a._id === b) resArr = [...resArr, ...a.ids];
	});
	return resArr;
}

export function getMatchedCount(array1, array2, type) {
	let totalCount = 0;
	_.intersectionWith(array1, array2, (a, b) => {
		if (a._id === b) totalCount++;
	});
	return { [type + "Total"]: totalCount };
}

export async function getArrayIds(array1) {
	let resArr = [];
	array1.map((item) => {
		if (item.ids.length > 0) {
			resArr = [...resArr, ...item.ids];
		}
		return true;
	});
	return resArr;
}

export async function checkArrayPermission(checkedPermission) {
	let response = false;
	const { permissions, user } = store.getState();
	const intersection = matchedArray(permissions, checkedPermission);
	if (intersection.length > 0 || user?.role.slug === "super") {
		response = true;
	} else {
		response = false;
	}
	return response;
}

export async function getChartFilterId(type, filter) {
	return { type, ids: filter[type] };
}

export function percentageLabel(percentage, type = "bracket") {
	percentage = percentage ? percentage : 0;

	// Convert to string to check for existing parentheses
	const percentageStr = String(percentage).trim();
	const hasParentheses = percentageStr.startsWith('(') && percentageStr.endsWith(')');

	if (type === "percentage") {
		// If already has parentheses, remove them and return with just %
		if (hasParentheses) {
			return percentageStr.slice(1, -1);
		}
		return `${percentage}%`;
	} else {
		// If percentage already has parentheses, return as is to avoid double parentheses
		if (hasParentheses) {
			return percentageStr;
		}
		return `(${percentage}%)`;
	}
}

//This function are used for nineteen days analysis
export async function updateListTotalValue(listData, matchedIds, type = "total", totalPatients = 0, totalFilter) {
	const { totalType, level = 0, intermediateTotals = {}, currentLevel = 0, cardTitles = {} } = totalFilter;
	if (listData && listData.length > 0) {
		// Extract patient IDs from intermediate totals for level calculations
		// Convert to strings for consistent comparison (handles both string and number IDs)
		const level1PatientIds = Array.isArray(intermediateTotals?.level1)
			? intermediateTotals.level1.map(p => String(p.id || p._id || '')).filter(id => id !== '')
			: [];
		const level2PatientIds = Array.isArray(intermediateTotals?.level2)
			? intermediateTotals.level2.map(p => String(p.id || p._id || '')).filter(id => id !== '')
			: [];
		const level3PatientIds = Array.isArray(intermediateTotals?.level3)
			? intermediateTotals.level3.map(p => String(p.id || p._id || '')).filter(id => id !== '')
			: [];
		const level4PatientIds = Array.isArray(intermediateTotals?.level4)
			? intermediateTotals.level4.map(p => String(p.id || p._id || '')).filter(id => id !== '')
			: [];
		const level5PatientIds = Array.isArray(intermediateTotals?.level5)
			? intermediateTotals.level5.map(p => String(p.id || p._id || '')).filter(id => id !== '')
			: [];

		const latestData = listData.map((RItem) => {
			// Check if this is a special item (total or average) that should preserve its value
			const isSpecialItem = RItem?.specialItem || RItem?.isSpacialItem || RItem?.type === 'total' || RItem?.type === 'average';

			const intersection = matchedArray(matchedIds, RItem.ids);
			let obj = {
				level,
				label: RItem?.label || "",
				_id: RItem?._id || "",
			};

			// For special items (total/average), preserve original values instead of recalculating
			if (isSpecialItem) {
				obj[type] = RItem?.value || RItem?.[type] || 0;
				obj.ids = RItem?.ids || [];
				obj.patientIds = RItem?.patientIds || [];
				obj.originalTotal = RItem?.originalTotal || 0;
				obj.percentage = itemPercentage(obj[type], totalPatients, "number");
				obj.isTooltip = RItem?.isTooltip !== undefined ? RItem.isTooltip : false;
				// Preserve specialItem property
				if (RItem?.specialItem) obj.specialItem = true;
				if (RItem?.isSpacialItem) obj.isSpacialItem = true;
			} else {
				// For regular range items, calculate normally
				obj[type] = intersection.length || 0;
				obj.ids = intersection;
				obj.patientIds = intersection;
				obj.percentage = itemPercentage(intersection.length, totalPatients, "number");

				if (totalType === TOTAL_TYPE.MAIN) {
					obj.originalTotal = intersection.length || 0;
					obj.isTooltip = false;
				} else {
					obj.originalTotal = RItem?.originalTotal || 0;
					obj.isTooltip = true;
				}
			}

			// Calculate level totals by matching patient IDs from intermediate totals with RItem.ids
			// Skip level calculations for special items (total/average) as they don't have matching IDs
			if (!isSpecialItem) {
				// Convert RItem.ids to strings for consistent comparison
				if (currentLevel >= 2) {
					if (level1PatientIds.length > 0 && RItem.ids && Array.isArray(RItem.ids) && RItem.ids.length > 0) {
						const rItemIdsAsStrings = RItem.ids.map(id => String(id));
						const level1Intersection = matchedArray(level1PatientIds, rItemIdsAsStrings);
						obj.level1Total = level1Intersection.length || 0;
					} else {
						obj.level1Total = 0;
					}
					if (cardTitles?.level1) {
						obj.level1CardTitle = cardTitles.level1;
					}
				}
				if (currentLevel >= 3) {
					if (level2PatientIds.length > 0 && RItem.ids && Array.isArray(RItem.ids) && RItem.ids.length > 0) {
						const rItemIdsAsStrings = RItem.ids.map(id => String(id));
						const level2Intersection = matchedArray(level2PatientIds, rItemIdsAsStrings);
						obj.level2Total = level2Intersection.length || 0;
					} else {
						obj.level2Total = 0;
					}
					if (cardTitles?.level2) {
						obj.level2CardTitle = cardTitles.level2;
					}
				}
				if (currentLevel >= 4) {
					if (level3PatientIds.length > 0 && RItem.ids && Array.isArray(RItem.ids) && RItem.ids.length > 0) {
						const rItemIdsAsStrings = RItem.ids.map(id => String(id));
						const level3Intersection = matchedArray(level3PatientIds, rItemIdsAsStrings);
						obj.level3Total = level3Intersection.length || 0;
					} else {
						obj.level3Total = 0;
					}
					if (cardTitles?.level3) {
						obj.level3CardTitle = cardTitles.level3;
					}
				}
				if (currentLevel >= 5) {
					if (level4PatientIds.length > 0 && RItem.ids && Array.isArray(RItem.ids) && RItem.ids.length > 0) {
						const rItemIdsAsStrings = RItem.ids.map(id => String(id));
						const level4Intersection = matchedArray(level4PatientIds, rItemIdsAsStrings);
						obj.level4Total = level4Intersection.length || 0;
					} else {
						obj.level4Total = 0;
					}
					if (cardTitles?.level4) {
						obj.level4CardTitle = cardTitles.level4;
					}
				}
				if (currentLevel >= 6) {
					if (level5PatientIds.length > 0 && RItem.ids && Array.isArray(RItem.ids) && RItem.ids.length > 0) {
						const rItemIdsAsStrings = RItem.ids.map(id => String(id));
						const level5Intersection = matchedArray(level5PatientIds, rItemIdsAsStrings);
						obj.level5Total = level5Intersection.length || 0;
					} else {
						obj.level5Total = 0;
					}
					if (cardTitles?.level5) {
						obj.level5CardTitle = cardTitles.level5;
					}
				}
			}

			const res = Object.assign({}, RItem, obj);
			return res;
		});
		return latestData;
	}
}

export async function filterListDataItems(dataGroupBy, type, totalPatient, totalFilter) {
	const {
		originalData = [],
		totalType = null,
		isOtherDashboard = false,
		isSpacialItem = false,
		level = 0,
		intermediateTotals = {},
		currentLevel = 0,
		groupByKey = null,
		cardTitles = {},
	} = totalFilter;

	let listGroup = [];
	let mainTotal = 0;
	if (dataGroupBy) {
		for await (const [key, value] of Object.entries(dataGroupBy)) {
			const valueArr = value[0];

			if (key && valueArr && valueArr[type]) {

				mainTotal += value?.length;
				let object = Object();
				object._id = key;
				object.id = key;
				object.label = valueArr[type].label;
				object.name = valueArr[type].label;
				object.total = value.length;
				object.value = value.length;
				let original = originalData[key] ? originalData[key]?.length : 0;
				object.originalTotal = original;
				object.isTooltip = totalType && totalType === TOTAL_TYPE.MAIN ? false : true;
				object.percentage = itemPercentage(value.length, totalPatient, "number");
				object.patientIds = isOtherDashboard ? value.map((item) => item.refPatientId) : value.map((item) => item._id);
				if (isOtherDashboard) {
					const patientIds = value.map((item) => item._id);
					const uniquePatientIds = [...new Set(patientIds || [])];
					object.otherDashboardIds = uniquePatientIds;
				}
				object.level = level;

				// Optional tooltip level totals (non-invasive to original totals)
				if (currentLevel >= 2) {
					const level1 = Array.isArray(intermediateTotals?.level1) ? intermediateTotals.level1 : [];
					const level2 = Array.isArray(intermediateTotals?.level2) ? intermediateTotals.level2 : [];
					const level3 = Array.isArray(intermediateTotals?.level3) ? intermediateTotals.level3 : [];
					const level4 = Array.isArray(intermediateTotals?.level4) ? intermediateTotals.level4 : [];
					const level5 = Array.isArray(intermediateTotals?.level5) ? intermediateTotals.level5 : [];
					const resolveKey = (p) => {
						// Prefer explicit groupByKey if provided, else try `${type}Id`, else fallback to type value/_id/id.
						if (groupByKey && p?.[groupByKey] !== undefined) return p[groupByKey];
						if (p?.[`${type}Id`] !== undefined) return p[`${type}Id`];
						if (p?.[type]?.label) return p?.[type]?.label;
						if (p?.[type]?.id !== undefined) return p?.[type]?.id;
						if (p?.[type]?._id !== undefined) return p?.[type]?._id;
						return p?.[type];
					};
					object.level1Total = level1.filter((p) => {
						const k = resolveKey(p);
						return k === key;
					}).length;
					if (currentLevel >= 2 && cardTitles?.level1) {
						object.level1CardTitle = cardTitles.level1;
					}
					if (currentLevel >= 3) {
						object.level2Total = level2.filter((p) => {
							const k = resolveKey(p);
							return k === key;
						}).length;
						if (cardTitles?.level2) {
							object.level2CardTitle = cardTitles.level2;
						}
					}
					if (currentLevel >= 4) {
						object.level3Total = level3.filter((p) => {
							const k = resolveKey(p);
							return k === key;
						}).length;
						if (cardTitles?.level3) {
							object.level3CardTitle = cardTitles.level3;
						}
					}
					if (currentLevel >= 5) {
						object.level4Total = level4.filter((p) => {
							const k = resolveKey(p);
							return k === key;
						}).length;
						if (cardTitles?.level4) {
							object.level4CardTitle = cardTitles.level4;
						}
					}
					if (currentLevel >= 6) {
						object.level5Total = level5.filter((p) => {
							const k = resolveKey(p);
							return k === key;
						}).length;
						if (cardTitles?.level5) {
							object.level5CardTitle = cardTitles.level5;
						}
					}
				}

				listGroup.push(object);
			}
		}
		if (listGroup.length > 0) {
			listGroup = _.orderBy(listGroup, "total", "desc");
		}

		if (isSpacialItem && mainTotal > 0) {
			const totalItem = {
				_id: "all",
				id: "all",
				label: "Total",
				name: "Total",
				total: mainTotal || 0,
				value: mainTotal || 0,
				originalTotal: mainTotal || 0,
				percentage: itemPercentage(mainTotal || 0, totalPatient, "number"),
				isSpacialItem: true,
			};

			listGroup.unshift(totalItem);
		}
	}
	return listGroup;
}

export const getPositivePlusSign = (value) => {
	if (value > 0) return `+${value}`;
	return `${value}`;
};

export const getDaysBetweenDates = (filter) => {
	const start = new Date(filter.startDate);
	const end = new Date(filter.endDate);

	const timeDiff = Math.abs(end - start);
	const parsedDiff = Math.round(timeDiff / (1000 * 60 * 60 * 24)) + 1;

	return parsedDiff;
};

export const updateCurrentFilterListData = (currentFilterListdata, latestFilterListData) => {
	const currentFilterListDataCopy = { ...currentFilterListdata };
	for (const key in latestFilterListData) {
		if (currentFilterListDataCopy.hasOwnProperty(key)) {
			currentFilterListDataCopy[key] = latestFilterListData?.[key] ?? [];
		}
	}
	return currentFilterListDataCopy;
};

export const areArraysDifferent = (arr1, arr2) => {
	if (arr1.length !== arr2.length) {
		return true; // Arrays are different if lengths are not equal
	}
	return !arr1.every((item) => arr2.includes(item)); // Check if every item in arr1 is in arr2
};

export const calcProPercentsBasedOnFilterAndDays = (value, filter, projectionDays, isPercentage, scale) => {
	if ((scale && isPercentage) || !isPercentage) {
		const days = getDaysBetweenDates(filter);
		const projectionDaysParsed = projectionDays === 0 || !projectionDays ? days : projectionDays;
		const scalingFactor = projectionDaysParsed / days;
		if (filter?.transferType === OVERALL_PAGE_SUB_TYPE.TOTAL && isPercentage) {
			const scaledValue = Number(value) * scalingFactor;
			const result = scaledValue < 1 ? scaledValue?.toFixed(1) || scaledValue : Math.round(scaledValue);
			return result > 0 ? `+${result}` : result;
		}
		if (filter?.transferType === OVERALL_PAGE_SUB_TYPE.TOTAL && !isPercentage) {
			return value;
		}
		const resCount = (Number(value) * scalingFactor) && (Number(value) * scalingFactor) < 1 ? (Number(value) * scalingFactor)?.toFixed(1) || (Number(value) * scalingFactor) : Math.round(Number(value) * scalingFactor);
		return resCount;
	} else {
		return value;
	}
};

export const getPercentageByTotal = (total, pageType = null) => {
	const { selectedAccount } = store.getState().common;
	if (selectedAccount && selectedAccount?.percentageBy === ACCOUNT_PERCENTAGE_BY.BED) {
		return total?.bedCapacity;
	} else {
		if (pageType === PAGE_TYPE.HOSPITAL) {
			const { percentageAgainst } = store.getState().hospital;
			return percentageAgainst;
		} else if (pageType === PAGE_TYPE.COMMUNITY_TRANSFER) {
			const { percentageAgainst } = store.getState().communityTransfer;
			return percentageAgainst;
		} else if (pageType === PAGE_TYPE.ADMISSION) {
			// CRITICAL: Admission page defaults to bed capacity, not census
			return total?.bedCapacity;
		} else {
			return total?.censusAverage;
		}
	}
};

export const getPercentageByType = (type = null) => {
	const { selectedAccount } = store.getState().common;
	if (selectedAccount && selectedAccount?.percentageBy === ACCOUNT_PERCENTAGE_BY.BED) {
		return type ? ACCOUNT_PERCENTAGE_BY.BED : _.capitalize(selectedAccount?.percentageBy);
	} else {
		return type ? ACCOUNT_PERCENTAGE_BY.CENSUS : _.capitalize(ACCOUNT_PERCENTAGE_BY.CENSUS);
	}
};

export const isOnlyHospitalTabAccess = () => {
	const { selectedAccount } = store.getState().common;
	const dashboardAccess = selectedAccount?.dashboardAccess ?? [];

	const hasHospital = dashboardAccess.includes(PAGE_TYPE.HOSPITAL);
	const hasOtherFlows = [PAGE_TYPE.ADMISSION, PAGE_TYPE.COMMUNITY_TRANSFER, PAGE_TYPE.DECEASED].some(tab =>
		dashboardAccess.includes(tab)
	);

	return hasHospital && !hasOtherFlows;
};

export const selectedTabAccess = () => {
	const { selectedAccount } = store.getState().common;
	const dashboardAccess = selectedAccount?.dashboardAccess ?? [PAGE_TYPE.HOSPITAL, PAGE_TYPE.COMMUNITY_TRANSFER, PAGE_TYPE.DECEASED, PAGE_TYPE.ADMISSION, PAGE_TYPE.OVERALL];
	return dashboardAccess;
};

export const isFullAccess = () => {
	const { selectedAccount } = store.getState().common;
	const dashboardAccess = selectedAccount?.dashboardAccess ?? [];
	if (dashboardAccess.length === [PAGE_TYPE.HOSPITAL, PAGE_TYPE.COMMUNITY_TRANSFER, PAGE_TYPE.DECEASED, PAGE_TYPE.ADMISSION, PAGE_TYPE.OVERALL].length) {
		return true;
	} else {
		return false;
	}
};

export const getAllowedActions = (selectedTab) => {
	const {
		HOSPITAL,
		DECEASED,
		COMMUNITY_TRANSFER,
		ADMISSION
	} = PAGE_TYPE;

	const allowTransferTypes = [HOSPITAL, DECEASED, COMMUNITY_TRANSFER];

	const allowTransfer = allowTransferTypes.some(type => selectedTab?.includes(type));
	const allowAdmission = selectedTab?.includes(ADMISSION) || false;
	const allowCommunityTransfer = selectedTab?.includes(COMMUNITY_TRANSFER) || false;
	const allowDeceased = selectedTab?.includes(DECEASED) || false;
	const allowHospitalTransfer = selectedTab?.includes(HOSPITAL) || false;

	return {
		allowTransfer,
		allowAdmission,
		allowCommunityTransfer,
		allowDeceased,
		allowHospitalTransfer
	};
};

export const isOnlyHospitalOrTransfer = (tabs = []) => {
	if (tabs.length === 1) {
		const hasOnlyOne = tabs.length === 1 &&
			[PAGE_TYPE.HOSPITAL, PAGE_TYPE.COMMUNITY_TRANSFER].includes(tabs[0]);
		return hasOnlyOne;
	}

	if (tabs.length === 2) {
		const hasOnly2 = tabs.length === 2 &&
			tabs.includes(PAGE_TYPE.HOSPITAL) &&
			tabs.includes(PAGE_TYPE.COMMUNITY_TRANSFER);
		return hasOnly2
	}
	return true;
};

export function getTooltipTitle(facilities, activeFacilities, type = "one") {
	// eslint-disable-next-line array-callback-return
	if (facilities && facilities === "refreshing") return null;
	const sFacilityNames = facilities?.map((facility) => {
		if (_.includes(type === "all" ? activeFacilities : activeFacilities.slice(1), facility._id)) {
			return facility?.name;
		}
		return undefined;
	})
		.filter((ele) => ele)
		.join(", ");

	return sFacilityNames;
}

export function getChartFacilityPercentageBy(response) {
	const { customPercentageLabel, percentageBy, customePercentages } = store.getState().common;

	if (percentageBy === percentageByEnum.bedCapacity) {
		return response?.bedByFacility || [];
	} else if (percentageBy === percentageByEnum.censusAverage) {
		return response?.censusByFacility || []
	} else if (percentageBy === percentageByEnum.censusAsOfNow) {
		return response?.censusAsOfNowByFacility || []
	} else if (percentageBy === customPercentageLabel) {
		let percentageNumber = _.find(customePercentages, { label: customPercentageLabel })?.customPercentage ?? 0;
		return response?.censusByFacility?.map((ele) => {
			return { ...ele, total: percentageNumber }
		});
	} else {
		return response?.censusByFacility || []
	}
}

export function getDynamicPercentageBy(dbData, percentageByType = null, isOnlyHospitalDashboard = false) {
	let percentageNumber = dbData?.censusAverage;
	const { percentageBy, customPercentageLabel, customPercentage, customePercentages } = store.getState().common;

	let type = percentageByType ? percentageByType : percentageBy;

	if (type === percentageByEnum.bedCapacity) {
		percentageNumber = dbData?.bedCapacity;
	} else if (type === percentageByEnum.censusAsOfNow && !isOnlyHospitalDashboard) {
		percentageNumber = dbData?.censusAsOfNow;
	} else if (type === percentageByEnum.customNumber) {
		percentageNumber = customPercentage;
	} else if (type === customPercentageLabel) {
		percentageNumber = _.find(customePercentages, { label: customPercentageLabel })?.customPercentage ?? 0;
	}

	return percentageNumber;
}

export function updateOrAddToArray(array, newObject, identifierKey) {
	if (!array || array.length === 0) return [newObject];

	const index = array?.findIndex(item => item[identifierKey] === newObject[identifierKey]);

	if (index !== -1) {
		// Object exists, update it
		array[index] = { ...array[index], ...newObject };
	} else {
		// Object doesn't exist, add it
		array.push(newObject);
	}

	return array;
}

/**
 * Sort patient rows for chart tables / exports.
 * @param {object} [options]
 * @param {(row: object) => string} [options.getTypeSortLabel] - Type column display string (when orderBy is "type")
 */
export const patientDataOrderBy = (patientData, order, orderBy, options = {}) => {
	const { getTypeSortLabel } = options;
	const missingPrimaryDateRank = () => (order === 'asc' ? Infinity : -Infinity);

	const dateSortMs = (raw) => {
		if (raw == null || raw === '') return null;
		const t = new Date(raw).getTime();
		return Number.isNaN(t) ? null : t;
	};

	/** Same rules as getMedicareExhaustionDate (overall-common) — kept here to avoid circular imports. */
	const exhaustionSortMs = (patient) => {
		if (!patient) return null;
		if (patient.exhaustionDate) {
			const m = moment(patient.exhaustionDate);
			if (m.isValid()) return m.valueOf();
		}
		if (patient.dateOfADT != null && patient.medicareDaysRemaining != null && patient.medicareDaysRemaining !== '') {
			const dateOfADT = moment(patient.dateOfADT);
			if (!dateOfADT.isValid()) return null;
			const daysRemaining =
				typeof patient.medicareDaysRemaining === 'string'
					? parseInt(patient.medicareDaysRemaining, 10)
					: patient.medicareDaysRemaining;
			if (Number.isNaN(daysRemaining) || daysRemaining < 0) return null;
			return dateOfADT.clone().add(daysRemaining, 'days').valueOf();
		}
		return null;
	};

	const defaultTypeSortLabel = (item) => {
		if (!item) return '';
		if (item.type === 'transfer' && item.transferType != null && item.transferType !== '') {
			return String(item.transferType);
		}
		return String(item.type || '');
	};

	const normalizeCellSortValue = (v) => {
		if (v == null) return '';
		if (typeof v === 'boolean') return v ? 1 : 0;
		if (typeof v === 'number') return v;
		if (typeof v === 'string') return v.toLowerCase();
		if (Array.isArray(v)) {
			if (v.length > 0 && v.every((x) => x && typeof x === 'object')) {
				return v
					.map((x) => x.label || x.name || '')
					.filter(Boolean)
					.join(', ')
					.toLowerCase();
			}
			return v.length;
		}
		if (typeof v === 'object') {
			if (v instanceof Date) {
				const ms = dateSortMs(v);
				return ms == null ? missingPrimaryDateRank() : ms;
			}
			if (v.label != null || v.name != null) {
				return String(v.label ?? v.name ?? '').toLowerCase();
			}
			return '';
		}
		return v;
	};

	const primarySortValue = (item) => {
		if (orderBy === 'dateOfLatestAdmission') {
			const raw = item?.dateOfLatestAdmission || item?.dateOfActualAdmission;
			const ms = dateSortMs(raw);
			return ms == null ? missingPrimaryDateRank() : ms;
		}
		if (orderBy === 'DOB' || orderBy === 'dateOfADT') {
			const ms = dateSortMs(item?.[orderBy]);
			return ms == null ? missingPrimaryDateRank() : ms;
		}
		if (orderBy === 'exhaustionDate') {
			const ms = exhaustionSortMs(item);
			return ms == null ? missingPrimaryDateRank() : ms;
		}
		if (orderBy === 'remaining') {
			const v = item?.medicareDaysRemaining;
			const n = typeof v === 'string' ? parseFloat(v, 10) : Number(v);
			return v == null || v === '' || Number.isNaN(n) ? missingPrimaryDateRank() : n;
		}
		if (orderBy === 'secondaryInsurance') {
			const sec = item?.secondaryInsurance;
			const label =
				sec && typeof sec === 'object' ? sec.label || sec.name || '' : sec != null ? String(sec) : '';
			return String(label).toLowerCase();
		}
		if (orderBy === 'hospitalDays') {
			const n = Number(item?.hospitalDays);
			return Number.isNaN(n) ? missingPrimaryDateRank() : n;
		}
		if (orderBy === 'countDay') {
			const n = Number(item?.countDay);
			return Number.isNaN(n) ? missingPrimaryDateRank() : n;
		}
		if (orderBy === 'type') {
			const s = getTypeSortLabel ? getTypeSortLabel(item) : defaultTypeSortLabel(item);
			return String(s != null ? s : '').toLowerCase();
		}
		if (orderBy === 'lastName' || orderBy === 'firstName' || orderBy === 'facilityName') {
			return String(item?.[orderBy] ?? '').toLowerCase();
		}
		return normalizeCellSortValue(item?.[orderBy]);
	};

	return _.orderBy(
		patientData,
		[
			primarySortValue,
			(item) => {
				const ms = dateSortMs(item?.dateOfADT);
				return ms == null ? Infinity : ms;
			},
		],
		[order, 'asc']
	);
};

/**
 * Returns a new object containing only the provided dot-notation paths.
 * Example:
 * pickObjectByPaths(data, ["activeFacilitiesCount", "filters.cardTitle"])
 */
export const pickObjectByPaths = (source = {}, paths = []) => {
	if (!source || typeof source !== 'object' || !Array.isArray(paths)) {
		return {};
	}

	const validPaths = paths
		.filter((p) => typeof p === "string")
		.map((p) => p.trim())
		.filter(Boolean);

	if (!validPaths.length) {
		return {};
	}

	const buildTree = (pathsArr) => {
		const tree = {};

		pathsArr.forEach((path) => {
			const segments = path.split(".").filter(Boolean);
			if (!segments.length) return;

			let currentLevel = tree;

			segments.forEach((segment, index) => {
				if (!currentLevel[segment]) {
					currentLevel[segment] = { includeSelf: false, children: {} };
				}

				if (index === segments.length - 1) {
					currentLevel[segment].includeSelf = true;
				} else {
					currentLevel = currentLevel[segment].children;
				}
			});
		});

		return tree;
	};

	const extractValues = (src, treeLevel) => {
		if (!src || typeof src !== "object") {
			return {};
		}

		return Object.entries(treeLevel).reduce((acc, [key, meta]) => {
			if (!Object.prototype.hasOwnProperty.call(src, key)) {
				return acc;
			}

			const value = src[key];
			const childResult = extractValues(value, meta.children);
			const hasChildPaths = Object.keys(meta.children || {}).length > 0;
			const hasChildValues = Object.keys(childResult).length > 0;

			if (hasChildPaths && hasChildValues) {
				acc[key] = childResult;
			} else if (!hasChildPaths && meta.includeSelf) {
				acc[key] = value;
			} else if (meta.includeSelf && !hasChildValues) {
				// This means the value was requested directly (e.g., "filters") and has no specific children to pick.
				acc[key] = value;
			}

			return acc;
		}, {});
	};

	const pathTree = buildTree(validPaths);
	return extractValues(source, pathTree);
};

/**
 * Determines the dashboard path based on the account's dashboard access permissions
 * @param {Object} selectedAccount - The selected account object with dashboardAccess array
 * @returns {string} The target dashboard path
 */
export const getDashboardPathByAccess = (selectedAccount) => {
	if (!selectedAccount?.dashboardAccess?.length) {
		return null;
	}

	if (_.includes(selectedAccount.dashboardAccess, "hospital")) {
		return "/dashboard/hospital";
	} else if (_.includes(selectedAccount.dashboardAccess, "communityTransfer")) {
		return "/dashboard/community-transfer";
	} else if (_.includes(selectedAccount.dashboardAccess, "deceased")) {
		return "/dashboard/deceased";
	} else if (_.includes(selectedAccount.dashboardAccess, "admission")) {
		return "/dashboard/admissions";
	} else if (_.includes(selectedAccount.dashboardAccess, "overall")) {
		return "/dashboard/overall";
	}

	return null;
};

/**
 * Processes custom range combined data for custom tabs with custom date analysis
 * @param {Object} question - The question object with isCustomTab and customTab properties
 * @param {Object} filterListData - The filter list data object
 * @param {string} type - The type/key to access in filterListData
 * @returns {Object} Object containing customRangeCombinedData array and filterListDataUpdated object
 */
export const processCustomRangeCombinedData = (question, filterListData, type) => {
	let customRangeCombinedData = [];

	if (question?.isCustomTab && (question?.customTab?.isCustomDateAnalysis || question?.isCustomDateAnalysis)) {
		let customRangeCombinedDataArr = filterListData?.[type];
		if (customRangeCombinedDataArr?.length > 0) {
			const customRangeCombinedDataItems = customRangeCombinedDataArr?.[0]?.customDataArray ?? [];
			customRangeCombinedData = customRangeCombinedDataItems?.map((item) => {
				return { ...item, isSpacialItem: false };
			});
		}
	}
	return { customRangeCombinedData };
};

export const mapQuestionToValues = (question) => {
	return {
		label: question.order?.label || question.label,
		tableLabel: question.order?.tableLabel || question.tableLabel,
		customQuestionInputType: question?.customQuestionInputType,
		customQuestionOptions: question?.customQuestionOptions,
		templateType: question?.templateType ?? QUESTIONS_TEMPLATE_TYPE.DX_CARD,
		numberRangeType: question?.customQuestionInputType === QUESTION_INPUT_TYPE.NUMBER_RANGE ? question?.numberRangeType : null,
		timeRangeType: question?.customQuestionInputType === QUESTION_INPUT_TYPE.TIME_TAB_RANGE ? question?.timeRangeType : null,
		autoFillEnabled: question?.autoFillEnabled || false,
		sourceTransitionType: question?.sourceTransitionType || '',
		sourceQuestionId: question?.sourceQuestionId || '',
		dateAnalysisStartQuestion: question?.dateAnalysisStartQuestion || '',
		dateAnalysisEndQuestion: question?.dateAnalysisEndQuestion || '',
		useCustomCardInDashboard: question?.useCustomCardInDashboard || false,
		description: question?.description || '',
		aiDescription: question?.aiDescription || '',
		existingAccessor: question?.existingAccessor || '',
		invisibleAnswerOptions: question?.invisibleAnswerOptions || false,
		dataInputLabel: question?.dataInputLabel || '',
		isArchived: question?.isArchived || false,
		isUniversal: question?.isUniversal || false,
		isCustom: !!question.customQuestionInputType
	};
};
